// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.plan-selection-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(195, 191, 191, 0.721);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  padding: 20px;
}
.plan-selection-modal-overlay .plan-selection-modal {
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
  border-radius: 16px;
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.3);
  max-width: 900px;
  width: 100%;
  max-height: 90vh;
  overflow-y: auto;
  animation: modalSlideIn 0.3s ease-out;
  border: 1px solid #e2e8f0;
}
@keyframes modalSlideIn {
  from {
    opacity: 0;
    transform: translateY(-20px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
.plan-selection-modal-overlay .plan-selection-modal .modal-header {
  padding: 16px 24px;
  display: flex;
  justify-content: flex-end;
  border-bottom: 1px solid #e2e8f0;
}
.plan-selection-modal-overlay .plan-selection-modal .modal-header .close-button {
  background: transparent;
  border: none;
  font-size: 24px;
  color: #4a5568;
  cursor: pointer;
  transition: color 0.3s ease;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.plan-selection-modal-overlay .plan-selection-modal .modal-header .close-button:hover:not(:disabled) {
  color: #2d3748;
}
.plan-selection-modal-overlay .plan-selection-modal .modal-header .close-button:disabled {
  color: #cbd5e0;
  cursor: not-allowed;
  opacity: 0.5;
}
.plan-selection-modal-overlay .plan-selection-modal .loading-container {
  padding: 60px 32px;
  text-align: center;
  color: #4a5568;
  font-size: 16px;
}
.plan-selection-modal-overlay .plan-selection-modal .company-info {
  padding: 24px 32px;
  text-align: center;
  border-bottom: 1px solid #e2e8f0;
  background: #f8fafc;
}
.plan-selection-modal-overlay .plan-selection-modal .company-info h2 {
  margin: 0 0 12px;
  font-size: 26px;
  font-weight: 700;
  color: #1a202c;
}
.plan-selection-modal-overlay .plan-selection-modal .company-info .contact-info {
  margin-bottom: 8px;
  font-size: 14px;
  color: #4a5568;
}
.plan-selection-modal-overlay .plan-selection-modal .company-info .contact-info span {
  margin: 0 4px;
}
.plan-selection-modal-overlay .plan-selection-modal .company-info .current-plan {
  font-size: 14px;
  color: #4a5568;
}
.plan-selection-modal-overlay .plan-selection-modal .company-info .current-plan strong {
  color: var(--primary-color);
  font-weight: 600;
}
.plan-selection-modal-overlay .plan-selection-modal .plan-content {
  padding: 32px;
}
.plan-selection-modal-overlay .plan-selection-modal .plan-content .section-title {
  margin: 0 0 20px;
  font-size: 18px;
  font-weight: 600;
  color: #2d3748;
}
.plan-selection-modal-overlay .plan-selection-modal .plan-content .plans-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
  margin-bottom: 32px;
}
.plan-selection-modal-overlay .plan-selection-modal .plan-content .plans-grid .plan-card {
  position: relative;
  background: white;
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  padding: 24px 20px;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
}
.plan-selection-modal-overlay .plan-selection-modal .plan-content .plans-grid .plan-card:hover {
  border-color: #cbd5e0;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
}
.plan-selection-modal-overlay .plan-selection-modal .plan-content .plans-grid .plan-card.selected {
  border-color: var(--primary-color);
  background: linear-gradient(135deg, rgba(102, 126, 234, 0.05) 0%, rgba(118, 75, 162, 0.05) 100%);
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);
}
.plan-selection-modal-overlay .plan-selection-modal .plan-content .plans-grid .plan-card.blurred {
  opacity: 0.5;
  filter: grayscale(40%);
}
.plan-selection-modal-overlay .plan-selection-modal .plan-content .plans-grid .plan-card.blurred:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  border-color: #cbd5e0;
}
.plan-selection-modal-overlay .plan-selection-modal .plan-content .plans-grid .plan-card.disabled {
  opacity: 0.4;
  cursor: not-allowed;
  pointer-events: none;
  background: #f7fafc;
  border-color: #e2e8f0;
}
.plan-selection-modal-overlay .plan-selection-modal .plan-content .plans-grid .plan-card.disabled:hover {
  transform: none;
  box-shadow: none;
  border-color: #e2e8f0;
}
.plan-selection-modal-overlay .plan-selection-modal .plan-content .plans-grid .plan-card.disabled h4, .plan-selection-modal-overlay .plan-selection-modal .plan-content .plans-grid .plan-card.disabled .price {
  color: #a0aec0;
}
.plan-selection-modal-overlay .plan-selection-modal .plan-content .plans-grid .plan-card.highlighted {
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.25);
  transform: scale(1.02);
}
.plan-selection-modal-overlay .plan-selection-modal .plan-content .plans-grid .plan-card.highlighted::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(102, 126, 234, 0.04) 0%, rgba(118, 75, 162, 0.04) 100%);
  pointer-events: none;
  border-radius: inherit;
  z-index: 0;
}
.plan-selection-modal-overlay .plan-selection-modal .plan-content .plans-grid .plan-card.highlighted:hover {
  transform: scale(1.03);
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.3);
}
.plan-selection-modal-overlay .plan-selection-modal .plan-content .plans-grid .plan-card .checkmark {
  position: absolute;
  top: 12px;
  right: 12px;
  color: var(--primary-color);
  font-size: 24px;
  z-index: 2;
}
.plan-selection-modal-overlay .plan-selection-modal .plan-content .plans-grid .plan-card .upgrade-badge {
  position: absolute;
  top: -12px;
  right: -12px;
  background: linear-gradient(135deg, var(--primary-color) 0%, #5a4ba0 100%);
  color: white;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 10px;
  font-weight: 600;
  z-index: 2;
  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.4);
  letter-spacing: 0.3px;
  text-transform: uppercase;
}
.plan-selection-modal-overlay .plan-selection-modal .plan-content .plans-grid .plan-card .current-plan-badge {
  position: absolute;
  top: -12px;
  right: -12px;
  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
  color: white;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 10px;
  font-weight: 600;
  z-index: 2;
  box-shadow: 0 2px 8px rgba(245, 158, 11, 0.4);
  letter-spacing: 0.3px;
  text-transform: uppercase;
}
.plan-selection-modal-overlay .plan-selection-modal .plan-content .plans-grid .plan-card h4 {
  margin: 0 0 12px;
  font-size: 20px;
  font-weight: 600;
  color: #2d3748;
  position: relative;
  z-index: 1;
}
.plan-selection-modal-overlay .plan-selection-modal .plan-content .plans-grid .plan-card .price {
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  color: var(--primary-color);
  position: relative;
  z-index: 1;
}
.plan-selection-modal-overlay .plan-selection-modal .plan-content .plans-grid .plan-card .price-container {
  position: relative;
  z-index: 1;
}
.plan-selection-modal-overlay .plan-selection-modal .plan-content .plans-grid .plan-card .price-container .base-price {
  margin: 0 0 6px;
  font-size: 17px;
  font-weight: 600;
  color: #2d3748;
}
.plan-selection-modal-overlay .plan-selection-modal .plan-content .plans-grid .plan-card .price-container .gst-info {
  margin: 0 0 6px;
  font-size: 13px;
  font-weight: 500;
  color: #718096;
}
.plan-selection-modal-overlay .plan-selection-modal .plan-content .plans-grid .plan-card .price-container .total-price {
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  color: var(--primary-color);
  padding-top: 6px;
  border-top: 1px solid #e2e8f0;
}
.plan-selection-modal-overlay .plan-selection-modal .plan-content .plans-grid .plan-card .price-container.enterprise-modern .enterprise-main {
  font-size: 20px;
  font-weight: 700;
  color: #2d3748;
  margin: 0 0 10px;
}
.plan-selection-modal-overlay .plan-selection-modal .plan-content .plans-grid .plan-card .price-container.enterprise-modern .enterprise-benefits {
  font-size: 13px;
  color: #718096;
  line-height: 1.5;
  margin: 0 0 12px;
}
.plan-selection-modal-overlay .plan-selection-modal .plan-content .plans-grid .plan-card .price-container.enterprise-modern .contact-badge {
  display: inline-block;
  background: linear-gradient(135deg, var(--primary-color) 0%, #5a4ba0 100%);
  color: white;
  padding: 6px 16px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  margin-top: 8px;
}
.plan-selection-modal-overlay .plan-selection-modal .plan-content .plans-grid .plan-card .price-container.enterprise-premium .enterprise-badge {
  display: inline-block;
  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
  color: white;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 600;
  margin-bottom: 10px;
  letter-spacing: 0.5px;
}
.plan-selection-modal-overlay .plan-selection-modal .plan-content .plans-grid .plan-card .price-container.enterprise-premium .enterprise-tagline {
  font-size: 18px;
  font-weight: 700;
  color: #2d3748;
  margin: 0 0 12px;
}
.plan-selection-modal-overlay .plan-selection-modal .plan-content .plans-grid .plan-card .price-container.enterprise-premium .enterprise-features-hint {
  font-size: 12px;
  color: #4a5568;
  line-height: 1.8;
  text-align: left;
  margin: 0;
}
.plan-selection-modal-overlay .plan-selection-modal .plan-content .plans-grid .plan-card .price-container.enterprise-value .enterprise-label {
  font-size: 16px;
  font-weight: 600;
  color: #2d3748;
  margin: 0 0 10px;
}
.plan-selection-modal-overlay .plan-selection-modal .plan-content .plans-grid .plan-card .price-container.enterprise-value .value-props {
  font-size: 12px;
  color: #4a5568;
  line-height: 1.8;
  text-align: left;
  margin: 0 0 10px;
}
.plan-selection-modal-overlay .plan-selection-modal .plan-content .plans-grid .plan-card .price-container.enterprise-value .pricing-note {
  font-size: 13px;
  font-weight: 600;
  color: var(--primary-color);
  margin: 0;
}
.plan-selection-modal-overlay .plan-selection-modal .plan-content .plans-grid .plan-card .price-container.enterprise-minimal .enterprise-heading {
  font-size: 20px;
  font-weight: 700;
  color: #2d3748;
  margin: 0 0 12px;
}
.plan-selection-modal-overlay .plan-selection-modal .plan-content .plans-grid .plan-card .price-container.enterprise-minimal .divider-line {
  width: 60%;
  height: 2px;
  background: linear-gradient(90deg, transparent, var(--primary-color), transparent);
  margin: 0 auto 12px;
}
.plan-selection-modal-overlay .plan-selection-modal .plan-content .plans-grid .plan-card .price-container.enterprise-minimal .enterprise-subtext {
  font-size: 13px;
  color: #718096;
  margin: 0 0 10px;
  line-height: 1.5;
}
.plan-selection-modal-overlay .plan-selection-modal .plan-content .plans-grid .plan-card .price-container.enterprise-minimal .action-text {
  font-size: 14px;
  font-weight: 600;
  color: var(--primary-color);
  margin: 0;
}
.plan-selection-modal-overlay .plan-selection-modal .plan-content .plans-grid .plan-card .price-container .custom-pricing {
  font-size: 20px;
  font-weight: 700;
  color: #2d3748;
  margin: 0 0 8px;
}
.plan-selection-modal-overlay .plan-selection-modal .plan-content .plans-grid .plan-card .price-container .enterprise-description,
.plan-selection-modal-overlay .plan-selection-modal .plan-content .plans-grid .plan-card .price-container .enterprise-note {
  font-size: 13px;
  color: #718096;
  line-height: 1.5;
  margin: 0;
}
.plan-selection-modal-overlay .plan-selection-modal .plan-content .billing-period-section {
  margin-bottom: 24px;
}
.plan-selection-modal-overlay .plan-selection-modal .plan-content .billing-period-section label {
  display: block;
  margin-bottom: 8px;
  font-size: 16px;
  font-weight: 600;
  color: #2d3748;
}
.plan-selection-modal-overlay .plan-selection-modal .plan-content .billing-period-section select {
  width: 100%;
  padding: 12px 16px;
  font-size: 15px;
  border: 2px solid #e2e8f0;
  border-radius: 8px;
  background: white;
  color: #2d3748;
  cursor: pointer;
  transition: border-color 0.3s ease;
}
.plan-selection-modal-overlay .plan-selection-modal .plan-content .billing-period-section select:focus {
  outline: none;
  border-color: var(--primary-color);
}
.plan-selection-modal-overlay .plan-selection-modal .plan-content .billing-period-section select:hover {
  border-color: #cbd5e0;
}
.plan-selection-modal-overlay .plan-selection-modal .plan-content .terms-section {
  margin-bottom: 24px;
}
.plan-selection-modal-overlay .plan-selection-modal .plan-content .terms-section .checkbox-label {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
}
.plan-selection-modal-overlay .plan-selection-modal .plan-content .terms-section .checkbox-label input[type=checkbox] {
  width: 18px;
  height: 18px;
  cursor: pointer;
}
.plan-selection-modal-overlay .plan-selection-modal .plan-content .terms-section .checkbox-label span {
  font-size: 14px;
  color: #4a5568;
}
.plan-selection-modal-overlay .plan-selection-modal .plan-content .terms-section .checkbox-label span .terms-link {
  color: var(--primary-color);
  text-decoration: none;
  font-weight: 600;
}
.plan-selection-modal-overlay .plan-selection-modal .plan-content .terms-section .checkbox-label span .terms-link:hover {
  text-decoration: underline;
}
.plan-selection-modal-overlay .plan-selection-modal .plan-content .payment-status-message {
  margin: 20px 0;
  padding: 16px 20px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  gap: 12px;
  animation: slideDown 0.3s ease-out;
}
@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.plan-selection-modal-overlay .plan-selection-modal .plan-content .payment-status-message .status-icon {
  flex-shrink: 0;
}
.plan-selection-modal-overlay .plan-selection-modal .plan-content .payment-status-message p {
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  line-height: 1.5;
}
.plan-selection-modal-overlay .plan-selection-modal .plan-content .payment-status-message.success {
  background: linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%);
  border: 2px solid #6ee7b7;
  color: #065f46;
}
.plan-selection-modal-overlay .plan-selection-modal .plan-content .payment-status-message.success .status-icon {
  color: #059669;
}
.plan-selection-modal-overlay .plan-selection-modal .plan-content .payment-status-message.error {
  background: linear-gradient(135deg, #fee2e2 0%, #fecaca 100%);
  border: 2px solid #fca5a5;
  color: #991b1b;
}
.plan-selection-modal-overlay .plan-selection-modal .plan-content .payment-status-message.error .status-icon {
  color: #dc2626;
}
.plan-selection-modal-overlay .plan-selection-modal .plan-content .payment-status-message.processing {
  background: linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%);
  border: 2px solid #93c5fd;
  color: #1e40af;
}
.plan-selection-modal-overlay .plan-selection-modal .plan-content .payment-status-message.processing .status-icon {
  color: #3b82f6;
}
.plan-selection-modal-overlay .plan-selection-modal .plan-content .modal-footer {
  text-align: center;
  padding-top: 24px;
  border-top: 1px solid #e2e8f0;
}
.plan-selection-modal-overlay .plan-selection-modal .plan-content .modal-footer .payment-button {
  background: var(--primary-color);
  color: white;
  border: none;
  border-radius: 10px;
  padding: 14px 40px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  width: 100%;
  max-width: 300px;
}
.plan-selection-modal-overlay .plan-selection-modal .plan-content .modal-footer .payment-button:hover:not(:disabled) {
  box-shadow: 0 8px 25px rgba(102, 126, 234, 0.6);
  transform: translateY(-2px);
}
.plan-selection-modal-overlay .plan-selection-modal .plan-content .modal-footer .payment-button:active:not(:disabled) {
  transform: translateY(0);
}
.plan-selection-modal-overlay .plan-selection-modal .plan-content .modal-footer .payment-button:disabled {
  background: #cbd5e0;
  cursor: not-allowed;
  opacity: 0.6;
}
.plan-selection-modal-overlay .plan-selection-modal .plan-content .modal-footer .go-back {
  margin: 16px 0 0;
  font-size: 14px;
  color: #4a5568;
}
.plan-selection-modal-overlay .plan-selection-modal .plan-content .modal-footer .go-back .back-link {
  background: none;
  border: none;
  color: var(--primary-color);
  font-weight: 600;
  cursor: pointer;
  text-decoration: none;
  padding: 0;
  font-size: 14px;
}
.plan-selection-modal-overlay .plan-selection-modal .plan-content .modal-footer .go-back .back-link:hover:not(:disabled) {
  text-decoration: underline;
}
.plan-selection-modal-overlay .plan-selection-modal .plan-content .modal-footer .go-back .back-link:disabled {
  color: #cbd5e0;
  cursor: not-allowed;
}
.plan-selection-modal-overlay .plan-selection-modal .premium-contact-form-container {
  padding: 32px;
  animation: fadeIn 0.3s ease-out;
}
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.plan-selection-modal-overlay .plan-selection-modal .premium-contact-form-container .form-header {
  text-align: center;
  margin-bottom: 32px;
}
.plan-selection-modal-overlay .plan-selection-modal .premium-contact-form-container .form-header h3 {
  font-size: 24px;
  font-weight: 700;
  color: #1a202c;
  margin: 0 0 12px;
}
.plan-selection-modal-overlay .plan-selection-modal .premium-contact-form-container .form-header p {
  font-size: 15px;
  color: #4a5568;
  line-height: 1.6;
  max-width: 600px;
  margin: 0 auto;
}
.plan-selection-modal-overlay .plan-selection-modal .premium-contact-form-container .form-notification {
  margin-bottom: 24px;
  padding: 14px 18px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  gap: 12px;
  animation: slideDown 0.3s ease-out;
}
@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.plan-selection-modal-overlay .plan-selection-modal .premium-contact-form-container .form-notification .notification-icon {
  flex-shrink: 0;
}
.plan-selection-modal-overlay .plan-selection-modal .premium-contact-form-container .form-notification p {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.5;
}
.plan-selection-modal-overlay .plan-selection-modal .premium-contact-form-container .form-notification.success {
  background: linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%);
  border: 2px solid #6ee7b7;
  color: #065f46;
}
.plan-selection-modal-overlay .plan-selection-modal .premium-contact-form-container .form-notification.success .notification-icon {
  color: #059669;
}
.plan-selection-modal-overlay .plan-selection-modal .premium-contact-form-container .form-notification.error {
  background: linear-gradient(135deg, #fee2e2 0%, #fecaca 100%);
  border: 2px solid #fca5a5;
  color: #991b1b;
}
.plan-selection-modal-overlay .plan-selection-modal .premium-contact-form-container .form-notification.error .notification-icon {
  color: #dc2626;
}
.plan-selection-modal-overlay .plan-selection-modal .premium-contact-form-container .form-notification.warning {
  background: linear-gradient(135deg, #fef3c7 0%, #fde68a 100%);
  border: 2px solid #fcd34d;
  color: #92400e;
}
.plan-selection-modal-overlay .plan-selection-modal .premium-contact-form-container .form-notification.warning .notification-icon {
  color: #d97706;
}
.plan-selection-modal-overlay .plan-selection-modal .premium-contact-form-container .contact-form .form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  margin-bottom: 16px;
}
.plan-selection-modal-overlay .plan-selection-modal .premium-contact-form-container .contact-form .form-group {
  margin-bottom: 16px;
}
.plan-selection-modal-overlay .plan-selection-modal .premium-contact-form-container .contact-form .form-group input,
.plan-selection-modal-overlay .plan-selection-modal .premium-contact-form-container .contact-form .form-group textarea {
  width: 100%;
  padding: 12px 16px;
  font-size: 15px;
  border: 2px solid #e2e8f0;
  border-radius: 8px;
  background: white;
  color: #2d3748;
  transition: border-color 0.3s ease;
  font-family: inherit;
}
.plan-selection-modal-overlay .plan-selection-modal .premium-contact-form-container .contact-form .form-group input:focus,
.plan-selection-modal-overlay .plan-selection-modal .premium-contact-form-container .contact-form .form-group textarea:focus {
  outline: none;
  border-color: var(--primary-color);
}
.plan-selection-modal-overlay .plan-selection-modal .premium-contact-form-container .contact-form .form-group input:hover:not(:disabled),
.plan-selection-modal-overlay .plan-selection-modal .premium-contact-form-container .contact-form .form-group textarea:hover:not(:disabled) {
  border-color: #cbd5e0;
}
.plan-selection-modal-overlay .plan-selection-modal .premium-contact-form-container .contact-form .form-group input:disabled,
.plan-selection-modal-overlay .plan-selection-modal .premium-contact-form-container .contact-form .form-group textarea:disabled {
  background: #f7fafc;
  cursor: not-allowed;
  opacity: 0.6;
}
.plan-selection-modal-overlay .plan-selection-modal .premium-contact-form-container .contact-form .form-group input::placeholder,
.plan-selection-modal-overlay .plan-selection-modal .premium-contact-form-container .contact-form .form-group textarea::placeholder {
  color: #a0aec0;
}
.plan-selection-modal-overlay .plan-selection-modal .premium-contact-form-container .contact-form .form-group textarea {
  resize: vertical;
  min-height: 120px;
}
.plan-selection-modal-overlay .plan-selection-modal .premium-contact-form-container .contact-form .form-actions {
  margin-top: 24px;
  text-align: center;
}
.plan-selection-modal-overlay .plan-selection-modal .premium-contact-form-container .contact-form .form-actions .submit-button {
  background: var(--primary-color);
  color: white;
  border: none;
  border-radius: 10px;
  padding: 14px 40px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  width: 100%;
  max-width: 300px;
}
.plan-selection-modal-overlay .plan-selection-modal .premium-contact-form-container .contact-form .form-actions .submit-button:hover:not(:disabled) {
  box-shadow: 0 8px 25px rgba(102, 126, 234, 0.6);
  transform: translateY(-2px);
}
.plan-selection-modal-overlay .plan-selection-modal .premium-contact-form-container .contact-form .form-actions .submit-button:active:not(:disabled) {
  transform: translateY(0);
}
.plan-selection-modal-overlay .plan-selection-modal .premium-contact-form-container .contact-form .form-actions .submit-button:disabled {
  background: #cbd5e0;
  cursor: not-allowed;
  opacity: 0.6;
}
.plan-selection-modal-overlay .plan-selection-modal .premium-contact-form-container .contact-form .form-actions .go-back {
  margin: 16px 0 0;
  font-size: 14px;
  color: #4a5568;
}
.plan-selection-modal-overlay .plan-selection-modal .premium-contact-form-container .contact-form .form-actions .go-back .back-link {
  background: none;
  border: none;
  color: var(--primary-color);
  font-weight: 600;
  cursor: pointer;
  text-decoration: none;
  padding: 0;
  font-size: 14px;
}
.plan-selection-modal-overlay .plan-selection-modal .premium-contact-form-container .contact-form .form-actions .go-back .back-link:hover:not(:disabled) {
  text-decoration: underline;
}
.plan-selection-modal-overlay .plan-selection-modal .premium-contact-form-container .contact-form .form-actions .go-back .back-link:disabled {
  color: #cbd5e0;
  cursor: not-allowed;
}
@media (max-width: 768px) {
  .plan-selection-modal-overlay {
    padding: 16px;
  }
  .plan-selection-modal-overlay .plan-selection-modal .company-info {
    padding: 20px 24px;
  }
  .plan-selection-modal-overlay .plan-selection-modal .company-info h2 {
    font-size: 22px;
  }
  .plan-selection-modal-overlay .plan-selection-modal .company-info .contact-info,
  .plan-selection-modal-overlay .plan-selection-modal .company-info .current-plan {
    font-size: 13px;
  }
  .plan-selection-modal-overlay .plan-selection-modal .plan-content {
    padding: 24px;
  }
  .plan-selection-modal-overlay .plan-selection-modal .plan-content .plans-grid {
    grid-template-columns: 1fr;
    gap: 16px;
  }
  .plan-selection-modal-overlay .plan-selection-modal .plan-content .plans-grid .plan-card.highlighted {
    transform: scale(1.01);
  }
  .plan-selection-modal-overlay .plan-selection-modal .plan-content .plans-grid .plan-card.highlighted:hover {
    transform: scale(1.02);
  }
  .plan-selection-modal-overlay .plan-selection-modal .plan-content .modal-footer .payment-button {
    max-width: 100%;
  }
  .plan-selection-modal-overlay .plan-selection-modal .premium-contact-form-container {
    padding: 24px;
  }
  .plan-selection-modal-overlay .plan-selection-modal .premium-contact-form-container .contact-form .form-row {
    grid-template-columns: 1fr;
  }
  .plan-selection-modal-overlay .plan-selection-modal .premium-contact-form-container .contact-form .form-actions .submit-button {
    max-width: 100%;
  }
}
@media (max-width: 480px) {
  .plan-selection-modal-overlay {
    padding: 0;
  }
  .plan-selection-modal-overlay .plan-selection-modal {
    margin: 0;
    border-radius: 0;
    height: 100vh;
    max-height: 100vh;
  }
  .plan-selection-modal-overlay .plan-selection-modal .company-info h2 {
    font-size: 20px;
  }
  .plan-selection-modal-overlay .plan-selection-modal .company-info .contact-info {
    flex-direction: column;
  }
  .plan-selection-modal-overlay .plan-selection-modal .company-info .contact-info span {
    display: block;
    margin: 2px 0;
  }
  .plan-selection-modal-overlay .plan-selection-modal .plan-content .plans-grid .plan-card {
    padding: 20px 16px;
  }
  .plan-selection-modal-overlay .plan-selection-modal .plan-content .plans-grid .plan-card.highlighted {
    transform: scale(1.01);
  }
  .plan-selection-modal-overlay .plan-selection-modal .plan-content .plans-grid .plan-card h4 {
    font-size: 18px;
  }
  .plan-selection-modal-overlay .plan-selection-modal .plan-content .plans-grid .plan-card .price {
    font-size: 16px;
  }
  .plan-selection-modal-overlay .plan-selection-modal .plan-content .plans-grid .plan-card .upgrade-badge {
    top: -10px;
    right: -10px;
    padding: 4px 10px;
    font-size: 9px;
  }
  .plan-selection-modal-overlay .plan-selection-modal .plan-content .plans-grid .plan-card .current-plan-badge {
    top: -10px;
    right: -10px;
    padding: 4px 10px;
    font-size: 9px;
  }
  .plan-selection-modal-overlay .plan-selection-modal .premium-contact-form-container {
    padding: 20px;
  }
  .plan-selection-modal-overlay .plan-selection-modal .premium-contact-form-container .form-header h3 {
    font-size: 20px;
  }
  .plan-selection-modal-overlay .plan-selection-modal .premium-contact-form-container .form-header p {
    font-size: 14px;
  }
}
.plan-selection-modal-overlay .comparison-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.75);
  backdrop-filter: blur(6px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10001;
  padding: 20px;
  animation: fadeIn 0.3s ease-out;
}
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.plan-selection-modal-overlay .comparison-modal-overlay .comparison-modal {
  background: white;
  border-radius: 16px;
  max-width: 1000px;
  width: 100%;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.5);
  animation: slideUp 0.3s ease-out;
}
@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.plan-selection-modal-overlay .comparison-modal-overlay .comparison-modal .comparison-header {
  padding: 24px 32px;
  border-bottom: 2px solid #e2e8f0;
  text-align: center;
  background: linear-gradient(135deg, #f8fafc 0%, #ffffff 100%);
}
.plan-selection-modal-overlay .comparison-modal-overlay .comparison-modal .comparison-header h3 {
  margin: 0 0 8px;
  font-size: 26px;
  font-weight: 700;
  color: #1a202c;
}
.plan-selection-modal-overlay .comparison-modal-overlay .comparison-modal .comparison-header p {
  margin: 0;
  font-size: 15px;
  color: #718096;
}
.plan-selection-modal-overlay .comparison-modal-overlay .comparison-modal .comparison-content {
  padding: 32px;
}
.plan-selection-modal-overlay .comparison-modal-overlay .comparison-modal .comparison-content .comparison-grid {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  gap: 24px;
  align-items: start;
}
.plan-selection-modal-overlay .comparison-modal-overlay .comparison-modal .comparison-content .comparison-grid .plan-column {
  background: #f8fafc;
  border-radius: 12px;
  overflow: hidden;
  border: 2px solid #e2e8f0;
}
.plan-selection-modal-overlay .comparison-modal-overlay .comparison-modal .comparison-content .comparison-grid .plan-column.current .column-header {
  background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%);
}
.plan-selection-modal-overlay .comparison-modal-overlay .comparison-modal .comparison-content .comparison-grid .plan-column.new {
  border-color: var(--primary-color);
  box-shadow: 0 4px 20px rgba(102, 126, 234, 0.2);
}
.plan-selection-modal-overlay .comparison-modal-overlay .comparison-modal .comparison-content .comparison-grid .plan-column.new .column-header {
  background: linear-gradient(135deg, var(--primary-color) 0%, #5a4ba0 100%);
  color: white;
  position: relative;
}
.plan-selection-modal-overlay .comparison-modal-overlay .comparison-modal .comparison-content .comparison-grid .plan-column.new .column-header .upgrade-badge {
  position: absolute;
  top: 12px;
  right: 12px;
  background: rgba(255, 255, 255, 0.25);
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.plan-selection-modal-overlay .comparison-modal-overlay .comparison-modal .comparison-content .comparison-grid .plan-column.new .column-header .plan-price {
  color: rgba(255, 255, 255, 0.95);
}
.plan-selection-modal-overlay .comparison-modal-overlay .comparison-modal .comparison-content .comparison-grid .plan-column .column-header {
  padding: 20px;
  text-align: center;
}
.plan-selection-modal-overlay .comparison-modal-overlay .comparison-modal .comparison-content .comparison-grid .plan-column .column-header h4 {
  margin: 0 0 8px;
  font-size: 14px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1px;
  opacity: 0.8;
}
.plan-selection-modal-overlay .comparison-modal-overlay .comparison-modal .comparison-content .comparison-grid .plan-column .column-header .plan-name {
  margin: 0 0 8px;
  font-size: 22px;
  font-weight: 700;
}
.plan-selection-modal-overlay .comparison-modal-overlay .comparison-modal .comparison-content .comparison-grid .plan-column .column-header .plan-price {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #4a5568;
}
.plan-selection-modal-overlay .comparison-modal-overlay .comparison-modal .comparison-content .comparison-grid .plan-column .column-body {
  padding: 20px;
  background: white;
}
.plan-selection-modal-overlay .comparison-modal-overlay .comparison-modal .comparison-content .comparison-grid .plan-column .column-body .limits-section {
  margin-bottom: 20px;
  padding-bottom: 20px;
  border-bottom: 1px solid #e2e8f0;
}
.plan-selection-modal-overlay .comparison-modal-overlay .comparison-modal .comparison-content .comparison-grid .plan-column .column-body .limits-section .limit-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
  font-size: 14px;
}
.plan-selection-modal-overlay .comparison-modal-overlay .comparison-modal .comparison-content .comparison-grid .plan-column .column-body .limits-section .limit-item .limit-label {
  color: #4a5568;
  font-weight: 500;
}
.plan-selection-modal-overlay .comparison-modal-overlay .comparison-modal .comparison-content .comparison-grid .plan-column .column-body .limits-section .limit-item .limit-value {
  color: #1a202c;
  font-weight: 700;
  font-size: 16px;
  display: flex;
  align-items: center;
  gap: 8px;
}
.plan-selection-modal-overlay .comparison-modal-overlay .comparison-modal .comparison-content .comparison-grid .plan-column .column-body .limits-section .limit-item .limit-value.improved {
  color: var(--primary-color);
}
.plan-selection-modal-overlay .comparison-modal-overlay .comparison-modal .comparison-content .comparison-grid .plan-column .column-body .limits-section .limit-item .limit-value .increase {
  font-size: 12px;
  color: #10b981;
  background: #d1fae5;
  padding: 2px 8px;
  border-radius: 8px;
  font-weight: 600;
}
.plan-selection-modal-overlay .comparison-modal-overlay .comparison-modal .comparison-content .comparison-grid .plan-column .column-body .features-section h5 {
  margin: 0 0 12px;
  font-size: 13px;
  font-weight: 600;
  text-transform: uppercase;
  color: #718096;
  letter-spacing: 0.5px;
}
.plan-selection-modal-overlay .comparison-modal-overlay .comparison-modal .comparison-content .comparison-grid .plan-column .column-body .features-section .feature-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 0;
  font-size: 14px;
  transition: all 0.2s ease;
}
.plan-selection-modal-overlay .comparison-modal-overlay .comparison-modal .comparison-content .comparison-grid .plan-column .column-body .features-section .feature-item.new-feature {
  background: linear-gradient(90deg, rgba(16, 185, 129, 0.1) 0%, transparent 100%);
  padding-left: 10px;
  margin-left: -10px;
  border-radius: 6px;
}
.plan-selection-modal-overlay .comparison-modal-overlay .comparison-modal .comparison-content .comparison-grid .plan-column .column-body .features-section .feature-item.new-feature .new-badge {
  margin-left: auto;
  background: #10b981;
  color: white;
  font-size: 10px;
  padding: 2px 8px;
  border-radius: 8px;
  font-weight: 600;
}
.plan-selection-modal-overlay .comparison-modal-overlay .comparison-modal .comparison-content .comparison-grid .plan-column .column-body .features-section .feature-item .feature-icon {
  width: 20px;
  font-weight: 700;
  font-size: 16px;
}
.plan-selection-modal-overlay .comparison-modal-overlay .comparison-modal .comparison-content .comparison-grid .plan-column .column-body .features-section .feature-item .feature-label {
  color: #2d3748;
}
.plan-selection-modal-overlay .comparison-modal-overlay .comparison-modal .comparison-content .comparison-grid .plan-column .column-body .features-section .feature-item.feature-enabled .feature-icon {
  color: #10b981;
}
.plan-selection-modal-overlay .comparison-modal-overlay .comparison-modal .comparison-content .comparison-grid .plan-column .column-body .features-section .feature-item.feature-disabled {
  opacity: 0.4;
}
.plan-selection-modal-overlay .comparison-modal-overlay .comparison-modal .comparison-content .comparison-grid .plan-column .column-body .features-section .feature-item.feature-disabled .feature-icon {
  color: #cbd5e0;
}
.plan-selection-modal-overlay .comparison-modal-overlay .comparison-modal .comparison-content .comparison-grid .arrow-column {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding-top: 100px;
}
.plan-selection-modal-overlay .comparison-modal-overlay .comparison-modal .comparison-content .comparison-grid .arrow-column .upgrade-arrow {
  font-size: 40px;
  color: var(--primary-color);
  font-weight: 700;
  animation: pulse 2s ease-in-out infinite;
}
.plan-selection-modal-overlay .comparison-modal-overlay .comparison-modal .comparison-content .comparison-grid .arrow-column .upgrade-text {
  font-size: 11px;
  font-weight: 700;
  color: var(--primary-color);
  letter-spacing: 1px;
  writing-mode: vertical-rl;
  text-orientation: mixed;
}
@keyframes pulse {
  0%, 100% {
    opacity: 1;
    transform: translateX(0);
  }
  50% {
    opacity: 0.7;
    transform: translateX(5px);
  }
}
.plan-selection-modal-overlay .comparison-modal-overlay .comparison-modal .comparison-footer {
  padding: 20px 32px;
  border-top: 2px solid #e2e8f0;
  display: flex;
  justify-content: center;
  gap: 16px;
  background: #f8fafc;
}
.plan-selection-modal-overlay .comparison-modal-overlay .comparison-modal .comparison-footer button {
  padding: 12px 32px;
  border-radius: 10px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  border: none;
}
.plan-selection-modal-overlay .comparison-modal-overlay .comparison-modal .comparison-footer button.cancel-button {
  background: white;
  color: #4a5568;
  border: 2px solid #e2e8f0;
}
.plan-selection-modal-overlay .comparison-modal-overlay .comparison-modal .comparison-footer button.cancel-button:hover {
  background: #f7fafc;
  border-color: #cbd5e0;
}
.plan-selection-modal-overlay .comparison-modal-overlay .comparison-modal .comparison-footer button.confirm-button {
  background: var(--primary-color);
  color: white;
}
.plan-selection-modal-overlay .comparison-modal-overlay .comparison-modal .comparison-footer button.confirm-button:hover {
  box-shadow: 0 8px 25px rgba(102, 126, 234, 0.6);
  transform: translateY(-2px);
}
@media (max-width: 768px) {
  .plan-selection-modal-overlay .comparison-modal-overlay .comparison-modal .comparison-content {
    padding: 20px;
  }
  .plan-selection-modal-overlay .comparison-modal-overlay .comparison-modal .comparison-content .comparison-grid {
    grid-template-columns: 1fr;
    gap: 16px;
  }
  .plan-selection-modal-overlay .comparison-modal-overlay .comparison-modal .comparison-content .comparison-grid .arrow-column {
    padding-top: 0;
  }
  .plan-selection-modal-overlay .comparison-modal-overlay .comparison-modal .comparison-content .comparison-grid .arrow-column .upgrade-arrow {
    transform: rotate(90deg);
    font-size: 30px;
  }
  .plan-selection-modal-overlay .comparison-modal-overlay .comparison-modal .comparison-content .comparison-grid .arrow-column .upgrade-text {
    writing-mode: horizontal-tb;
  }
}

.plan-comparison-container {
  margin: 24px 0;
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  border-radius: 12px;
  border: 2px solid #cbd5e0;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}
.plan-comparison-container .comparison-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  background: linear-gradient(135deg, #004A9A 0%, #0066cc 100%);
  cursor: pointer;
  transition: background 0.3s ease;
}
.plan-comparison-container .comparison-header:hover {
  background: linear-gradient(135deg, #003a7a 0%, #0055aa 100%);
}
.plan-comparison-container .comparison-header h4 {
  margin: 0;
  color: white;
  font-size: 18px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 10px;
}
.plan-comparison-container .comparison-header h4 .compare-icon {
  color: #4ade80;
  font-size: 20px;
}
.plan-comparison-container .comparison-header .toggle-btn {
  background: rgba(255, 255, 255, 0.2);
  color: white;
  border: 1px solid rgba(255, 255, 255, 0.3);
  padding: 6px 14px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  transition: all 0.3s ease;
}
.plan-comparison-container .comparison-header .toggle-btn:hover {
  background: rgba(255, 255, 255, 0.3);
}
.plan-comparison-container .comparison-content {
  padding: 20px;
  background: white;
}
.plan-comparison-container .comparison-content h5 {
  margin: 0 0 14px 0;
  font-size: 16px;
  font-weight: 600;
  color: #1a202c;
  border-bottom: 2px solid #e2e8f0;
  padding-bottom: 8px;
}
.plan-comparison-container .comparison-content .limits-section {
  margin-bottom: 24px;
}
.plan-comparison-container .comparison-content .limits-section .limits-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 16px;
  margin-top: 12px;
}
.plan-comparison-container .comparison-content .limits-section .limits-grid .limit-item {
  background: #f8fafc;
  border-radius: 10px;
  padding: 16px;
  border: 2px solid #e2e8f0;
  transition: all 0.3s ease;
}
.plan-comparison-container .comparison-content .limits-section .limits-grid .limit-item.upgrade {
  border-color: #4ade80;
  background: #f0fdf4;
}
.plan-comparison-container .comparison-content .limits-section .limits-grid .limit-item.downgrade {
  border-color: #fbbf24;
  background: #fffbeb;
}
.plan-comparison-container .comparison-content .limits-section .limits-grid .limit-item .limit-label {
  font-size: 13px;
  color: #64748b;
  font-weight: 500;
  margin-bottom: 8px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.plan-comparison-container .comparison-content .limits-section .limits-grid .limit-item .limit-comparison {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin: 12px 0;
}
.plan-comparison-container .comparison-content .limits-section .limits-grid .limit-item .limit-comparison .current-value {
  font-size: 24px;
  font-weight: 700;
  color: #64748b;
}
.plan-comparison-container .comparison-content .limits-section .limits-grid .limit-item .limit-comparison .arrow {
  color: #004A9A;
  font-size: 18px;
  display: flex;
  align-items: center;
}
.plan-comparison-container .comparison-content .limits-section .limits-grid .limit-item .limit-comparison .new-value {
  font-size: 24px;
  font-weight: 700;
  color: #004A9A;
}
.plan-comparison-container .comparison-content .limits-section .limits-grid .limit-item .change-badge {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  text-align: center;
}
.plan-comparison-container .comparison-content .limits-section .limits-grid .limit-item .change-badge.positive {
  background: #d1fae5;
  color: #065f46;
}
.plan-comparison-container .comparison-content .limits-section .limits-grid .limit-item .change-badge.negative {
  background: #fee2e2;
  color: #991b1b;
}
.plan-comparison-container .comparison-content .features-section {
  margin-bottom: 24px;
}
.plan-comparison-container .comparison-content .features-section .features-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 12px;
  margin-top: 12px;
}
.plan-comparison-container .comparison-content .features-section .features-grid .feature-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  background: #f8fafc;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  transition: all 0.3s ease;
  position: relative;
}
.plan-comparison-container .comparison-content .features-section .features-grid .feature-item.added {
  background: #f0fdf4;
  border-color: #4ade80;
}
.plan-comparison-container .comparison-content .features-section .features-grid .feature-item.removed {
  background: #fef2f2;
  border-color: #f87171;
}
.plan-comparison-container .comparison-content .features-section .features-grid .feature-item:hover {
  transform: translateX(4px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}
.plan-comparison-container .comparison-content .features-section .features-grid .feature-item .feature-label {
  font-size: 14px;
  color: #1a202c;
  font-weight: 500;
  flex: 1 1;
}
.plan-comparison-container .comparison-content .features-section .features-grid .feature-item .feature-status {
  display: flex;
  align-items: center;
  gap: 8px;
}
.plan-comparison-container .comparison-content .features-section .features-grid .feature-item .feature-status .has-feature {
  color: #10b981;
  font-size: 16px;
}
.plan-comparison-container .comparison-content .features-section .features-grid .feature-item .feature-status .has-feature.new {
  color: #004A9A;
  font-weight: bold;
}
.plan-comparison-container .comparison-content .features-section .features-grid .feature-item .feature-status .no-feature {
  color: #ef4444;
  font-size: 16px;
}
.plan-comparison-container .comparison-content .features-section .features-grid .feature-item .feature-status .no-feature.new {
  color: #dc2626;
}
.plan-comparison-container .comparison-content .features-section .features-grid .feature-item .feature-status .arrow {
  color: #64748b;
  font-size: 14px;
  margin: 0 4px;
}
.plan-comparison-container .comparison-content .features-section .features-grid .feature-item .feature-badge {
  position: absolute;
  top: -6px;
  right: 8px;
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.plan-comparison-container .comparison-content .features-section .features-grid .feature-item .feature-badge.added {
  background: #10b981;
  color: white;
}
.plan-comparison-container .comparison-content .features-section .features-grid .feature-item .feature-badge.removed {
  background: #ef4444;
  color: white;
}
.plan-comparison-container .comparison-content .price-section .price-comparison {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
  margin: 16px 0;
  padding: 16px;
  background: #f8fafc;
  border-radius: 10px;
}
.plan-comparison-container .comparison-content .price-section .price-comparison .price-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
}
.plan-comparison-container .comparison-content .price-section .price-comparison .price-item.new .value {
  color: #004A9A;
  font-weight: 700;
}
.plan-comparison-container .comparison-content .price-section .price-comparison .price-item .label {
  font-size: 13px;
  color: #64748b;
  font-weight: 500;
}
.plan-comparison-container .comparison-content .price-section .price-comparison .price-item .value {
  font-size: 22px;
  font-weight: 600;
  color: #1a202c;
}
.plan-comparison-container .comparison-content .price-section .price-comparison .price-arrow {
  font-size: 24px;
  color: #004A9A;
  font-weight: bold;
}
.plan-comparison-container .comparison-content .price-section .price-difference {
  text-align: center;
  padding: 12px;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 600;
  margin-top: 12px;
}
.plan-comparison-container .comparison-content .price-section .price-difference.increase {
  background: #fef3c7;
  color: #92400e;
  border: 1px solid #fbbf24;
}
.plan-comparison-container .comparison-content .price-section .price-difference.decrease {
  background: #d1fae5;
  color: #065f46;
  border: 1px solid #34d399;
}

@media (max-width: 768px) {
  .plan-comparison-container {
    margin: 16px 0;
  }
  .plan-comparison-container .comparison-header h4 {
    font-size: 15px;
  }
  .plan-comparison-container .comparison-header .toggle-btn {
    font-size: 11px;
    padding: 4px 10px;
  }
  .plan-comparison-container .comparison-content {
    padding: 16px;
  }
  .plan-comparison-container .comparison-content h5 {
    font-size: 14px;
  }
  .plan-comparison-container .comparison-content .limits-section .limits-grid {
    grid-template-columns: 1fr;
    gap: 12px;
  }
  .plan-comparison-container .comparison-content .features-section .features-grid {
    grid-template-columns: 1fr;
  }
  .plan-comparison-container .comparison-content .price-section .price-comparison {
    flex-direction: column;
    gap: 12px;
  }
  .plan-comparison-container .comparison-content .price-section .price-comparison .price-arrow {
    transform: rotate(90deg);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/PlanSelectionModal/PlanSelectionModal.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,4CAAA;EACA,0BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,aAAA;AACF;AACE;EACE,6DAAA;EACA,mBAAA;EACA,0CAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,qCAAA;EACA,yBAAA;AACJ;AACI;EACE;IACE,UAAA;IACA,wCAAA;EACN;EACI;IACE,UAAA;IACA,iCAAA;EACN;AACF;AAEI;EACE,kBAAA;EACA,aAAA;EACA,yBAAA;EACA,gCAAA;AAAN;AAEM;EACE,uBAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,2BAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAAR;AAEQ;EACE,cAAA;AAAV;AAGQ;EACE,cAAA;EACA,mBAAA;EACA,YAAA;AADV;AAMI;EACE,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;AAJN;AAOI;EACE,kBAAA;EACA,kBAAA;EACA,gCAAA;EACA,mBAAA;AALN;AAOM;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AALR;AAQM;EACE,kBAAA;EACA,eAAA;EACA,cAAA;AANR;AAQQ;EACE,aAAA;AANV;AAUM;EACE,eAAA;EACA,cAAA;AARR;AAUQ;EACE,2BAAA;EACA,gBAAA;AARV;AAaI;EACE,aAAA;AAXN;AAaM;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAXR;AAcM;EACE,aAAA;EACA,qCAAA;EACA,SAAA;EACA,mBAAA;AAZR;AAcQ;EACE,kBAAA;EACA,iBAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;AAZV;AAcU;EACE,qBAAA;EACA,yCAAA;EACA,2BAAA;AAZZ;AAeU;EACE,kCAAA;EACA,gGAAA;EACA,+CAAA;AAbZ;AAgBU;EACE,YAAA;EACA,sBAAA;AAdZ;AAgBY;EACE,2BAAA;EACA,yCAAA;EACA,qBAAA;AAdd;AAkBU;EACE,YAAA;EACA,mBAAA;EACA,oBAAA;EACA,mBAAA;EACA,qBAAA;AAhBZ;AAkBY;EACE,eAAA;EACA,gBAAA;EACA,qBAAA;AAhBd;AAmBY;EACE,cAAA;AAjBd;AAqBS;EACG,gDAAA;EACA,sBAAA;AAnBZ;AAqBY;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,gGAAA;EACA,oBAAA;EACA,sBAAA;EACA,UAAA;AAnBd;AAsBY;EACE,sBAAA;EACA,+CAAA;AApBd;AAwBU;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,2BAAA;EACA,eAAA;EACA,UAAA;AAtBZ;AAyBU;EACE,kBAAA;EACA,UAAA;EACA,YAAA;EACA,0EAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,UAAA;EACA,8CAAA;EACA,qBAAA;EACA,yBAAA;AAvBZ;AA0BU;EACE,kBAAA;EACA,UAAA;EACA,YAAA;EACA,6DAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,UAAA;EACA,6CAAA;EACA,qBAAA;EACA,yBAAA;AAxBZ;AA2BU;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,UAAA;AAzBZ;AA4BU;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,2BAAA;EACA,kBAAA;EACA,UAAA;AA1BZ;AA6BU;EACE,kBAAA;EACA,UAAA;AA3BZ;AA6BY;EACE,eAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AA3Bd;AA8BY;EACE,eAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AA5Bd;AA+BY;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,2BAAA;EACA,gBAAA;EACA,6BAAA;AA7Bd;AAiCM;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AA/BR;AAkCM;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;AAhCR;AAmCM;EACE,qBAAA;EACA,0EAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;AAjCR;AAsCM;EACE,qBAAA;EACA,6DAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;AApCR;AAuCM;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AArCR;AAwCM;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,SAAA;AAtCR;AA2CM;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AAzCR;AA4CM;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;AA1CR;AA6CM;EACE,eAAA;EACA,gBAAA;EACA,2BAAA;EACA,SAAA;AA3CR;AAgDM;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AA9CR;AAiDM;EACE,UAAA;EACA,WAAA;EACA,kFAAA;EACA,mBAAA;AA/CR;AAkDM;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;AAhDR;AAmDM;EACE,eAAA;EACA,gBAAA;EACA,2BAAA;EACA,SAAA;AAjDR;AAsDI;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;AApDN;AAuDI;;EAEE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,SAAA;AArDN;AA2DM;EACE,mBAAA;AAzDR;AA2DQ;EACE,cAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAzDV;AA4DQ;EACE,WAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;EACA,kCAAA;AA1DV;AA4DU;EACE,aAAA;EACA,kCAAA;AA1DZ;AA6DU;EACE,qBAAA;AA3DZ;AAgEM;EACE,mBAAA;AA9DR;AAgEQ;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;AA9DV;AAgEU;EACE,WAAA;EACA,YAAA;EACA,eAAA;AA9DZ;AAiEU;EACE,eAAA;EACA,cAAA;AA/DZ;AAiEY;EACE,2BAAA;EACA,qBAAA;EACA,gBAAA;AA/Dd;AAiEc;EACE,0BAAA;AA/DhB;AAsEM;EACE,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kCAAA;AApER;AAsEQ;EACE;IACE,UAAA;IACA,4BAAA;EApEV;EAsEQ;IACE,UAAA;IACA,wBAAA;EApEV;AACF;AAuEQ;EACE,cAAA;AArEV;AAwEQ;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AAtEV;AAyEQ;EACE,6DAAA;EACA,yBAAA;EACA,cAAA;AAvEV;AAyEU;EACE,cAAA;AAvEZ;AA2EQ;EACE,6DAAA;EACA,yBAAA;EACA,cAAA;AAzEV;AA2EU;EACE,cAAA;AAzEZ;AA6EQ;EACE,6DAAA;EACA,yBAAA;EACA,cAAA;AA3EV;AA6EU;EACE,cAAA;AA3EZ;AAgFM;EACE,kBAAA;EACA,iBAAA;EACA,6BAAA;AA9ER;AAgFQ;EACE,gCAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,WAAA;EACA,gBAAA;AA9EV;AAgFU;EACE,+CAAA;EACA,2BAAA;AA9EZ;AAiFU;EACE,wBAAA;AA/EZ;AAkFU;EACE,mBAAA;EACA,mBAAA;EACA,YAAA;AAhFZ;AAoFQ;EACE,gBAAA;EACA,eAAA;EACA,cAAA;AAlFV;AAoFU;EACE,gBAAA;EACA,YAAA;EACA,2BAAA;EACA,gBAAA;EACA,eAAA;EACA,qBAAA;EACA,UAAA;EACA,eAAA;AAlFZ;AAoFY;EACE,0BAAA;AAlFd;AAqFY;EACE,cAAA;EACA,mBAAA;AAnFd;AA2FI;EACE,aAAA;EACA,+BAAA;AAzFN;AA2FM;EACE;IACE,UAAA;EAzFR;EA2FM;IACE,UAAA;EAzFR;AACF;AA4FM;EACE,kBAAA;EACA,mBAAA;AA1FR;AA4FQ;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AA1FV;AA6FQ;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;AA3FV;AA+FM;EACE,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kCAAA;AA7FR;AA+FQ;EACE;IACE,UAAA;IACA,4BAAA;EA7FV;EA+FQ;IACE,UAAA;IACA,wBAAA;EA7FV;AACF;AAgGQ;EACE,cAAA;AA9FV;AAiGQ;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AA/FV;AAkGQ;EACE,6DAAA;EACA,yBAAA;EACA,cAAA;AAhGV;AAkGU;EACE,cAAA;AAhGZ;AAoGQ;EACE,6DAAA;EACA,yBAAA;EACA,cAAA;AAlGV;AAoGU;EACE,cAAA;AAlGZ;AAsGQ;EACE,6DAAA;EACA,yBAAA;EACA,cAAA;AApGV;AAsGU;EACE,cAAA;AApGZ;AA0GQ;EACE,aAAA;EACA,8BAAA;EACA,SAAA;EACA,mBAAA;AAxGV;AA2GQ;EACE,mBAAA;AAzGV;AA2GU;;EAEE,WAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,cAAA;EACA,kCAAA;EACA,oBAAA;AAzGZ;AA2GY;;EACE,aAAA;EACA,kCAAA;AAxGd;AA2GY;;EACE,qBAAA;AAxGd;AA2GY;;EACE,mBAAA;EACA,mBAAA;EACA,YAAA;AAxGd;AA2GY;;EACE,cAAA;AAxGd;AA4GU;EACE,gBAAA;EACA,iBAAA;AA1GZ;AA8GQ;EACE,gBAAA;EACA,kBAAA;AA5GV;AA8GU;EACE,gCAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,WAAA;EACA,gBAAA;AA5GZ;AA8GY;EACE,+CAAA;EACA,2BAAA;AA5Gd;AA+GY;EACE,wBAAA;AA7Gd;AAgHY;EACE,mBAAA;EACA,mBAAA;EACA,YAAA;AA9Gd;AAkHU;EACE,gBAAA;EACA,eAAA;EACA,cAAA;AAhHZ;AAkHY;EACE,gBAAA;EACA,YAAA;EACA,2BAAA;EACA,gBAAA;EACA,eAAA;EACA,qBAAA;EACA,UAAA;EACA,eAAA;AAhHd;AAkHc;EACE,0BAAA;AAhHhB;AAmHc;EACE,cAAA;EACA,mBAAA;AAjHhB;AA2HE;EA1yBF;IA2yBI,aAAA;EAxHF;EA2HI;IACE,kBAAA;EAzHN;EA2HM;IACE,eAAA;EAzHR;EA4HM;;IAEE,eAAA;EA1HR;EA8HI;IACE,aAAA;EA5HN;EA8HM;IACE,0BAAA;IACA,SAAA;EA5HR;EA+HU;IACE,sBAAA;EA7HZ;EA+HY;IACE,sBAAA;EA7Hd;EAoIQ;IACE,eAAA;EAlIV;EAuII;IACE,aAAA;EArIN;EAwIQ;IACE,0BAAA;EAtIV;EA0IU;IACE,eAAA;EAxIZ;AACF;AA+IE;EAt2BF;IAu2BI,UAAA;EA5IF;EA8IE;IACE,SAAA;IACA,gBAAA;IACA,aAAA;IACA,iBAAA;EA5IJ;EA+IM;IACE,eAAA;EA7IR;EAgJM;IACE,sBAAA;EA9IR;EAgJQ;IACE,cAAA;IACA,aAAA;EA9IV;EAqJQ;IACE,kBAAA;EAnJV;EAqJU;IACE,sBAAA;EAnJZ;EAsJU;IACE,eAAA;EApJZ;EAuJU;IACE,eAAA;EArJZ;EAwJU;IACE,UAAA;IACA,YAAA;IACA,iBAAA;IACA,cAAA;EAtJZ;EAyJU;IACE,UAAA;IACA,YAAA;IACA,iBAAA;IACA,cAAA;EAvJZ;EA6JI;IACE,aAAA;EA3JN;EA8JQ;IACE,eAAA;EA5JV;EA+JQ;IACE,eAAA;EA7JV;AACF;AAkKE;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,+BAAA;EACA,0BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,aAAA;EACA,+BAAA;AAhKJ;AAkKI;EACE;IAAO,UAAA;EA/JX;EAgKI;IAAK,UAAA;EA7JT;AACF;AA+JI;EACE,iBAAA;EACA,mBAAA;EACA,iBAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,0CAAA;EACA,gCAAA;AA7JN;AA+JM;EACE;IACE,UAAA;IACA,2BAAA;EA7JR;EA+JM;IACE,UAAA;IACA,wBAAA;EA7JR;AACF;AAgKM;EACE,kBAAA;EACA,gCAAA;EACA,kBAAA;EACA,6DAAA;AA9JR;AAgKQ;EACE,eAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AA9JV;AAiKQ;EACE,SAAA;EACA,eAAA;EACA,cAAA;AA/JV;AAmKM;EACE,aAAA;AAjKR;AAmKQ;EACE,aAAA;EACA,mCAAA;EACA,SAAA;EACA,kBAAA;AAjKV;AAmKU;EACE,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBAAA;AAjKZ;AAoKc;EACE,6DAAA;AAlKhB;AAsKY;EACE,kCAAA;EACA,+CAAA;AApKd;AAsKc;EACE,0EAAA;EACA,YAAA;EACA,kBAAA;AApKhB;AAsKgB;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,qCAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;AApKlB;AAuKgB;EACE,gCAAA;AArKlB;AA0KY;EACE,aAAA;EACA,kBAAA;AAxKd;AA0Kc;EACE,eAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,YAAA;AAxKhB;AA2Kc;EACE,eAAA;EACA,eAAA;EACA,gBAAA;AAzKhB;AA4Kc;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AA1KhB;AA8KY;EACE,aAAA;EACA,iBAAA;AA5Kd;AA8Kc;EACE,mBAAA;EACA,oBAAA;EACA,gCAAA;AA5KhB;AA8KgB;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;EACA,eAAA;AA5KlB;AA8KkB;EACE,cAAA;EACA,gBAAA;AA5KpB;AA+KkB;EACE,cAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AA7KpB;AA+KoB;EACE,2BAAA;AA7KtB;AAgLoB;EACE,eAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;AA9KtB;AAqLgB;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,cAAA;EACA,qBAAA;AAnLlB;AAsLgB;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,cAAA;EACA,eAAA;EACA,yBAAA;AApLlB;AAsLkB;EACE,gFAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;AApLpB;AAsLoB;EACE,iBAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;AApLtB;AAwLkB;EACE,WAAA;EACA,gBAAA;EACA,eAAA;AAtLpB;AAyLkB;EACE,cAAA;AAvLpB;AA2LoB;EACE,cAAA;AAzLtB;AA6LkB;EACE,YAAA;AA3LpB;AA6LoB;EACE,cAAA;AA3LtB;AAmMU;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,kBAAA;AAjMZ;AAmMY;EACE,eAAA;EACA,2BAAA;EACA,gBAAA;EACA,wCAAA;AAjMd;AAoMY;EACE,eAAA;EACA,gBAAA;EACA,2BAAA;EACA,mBAAA;EACA,yBAAA;EACA,uBAAA;AAlMd;AAqMY;EACE;IAAW,UAAA;IAAY,wBAAA;EAjMnC;EAkMY;IAAM,YAAA;IAAc,0BAAA;EA9LhC;AACF;AAmMM;EACE,kBAAA;EACA,6BAAA;EACA,aAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;AAjMR;AAmMQ;EACE,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,YAAA;AAjMV;AAmMU;EACE,iBAAA;EACA,cAAA;EACA,yBAAA;AAjMZ;AAmMY;EACE,mBAAA;EACA,qBAAA;AAjMd;AAqMU;EACE,gCAAA;EACA,YAAA;AAnMZ;AAqMY;EACE,+CAAA;EACA,2BAAA;AAnMd;AA2MI;EAEI;IACE,aAAA;EA1MR;EA4MQ;IACE,0BAAA;IACA,SAAA;EA1MV;EA4MU;IACE,cAAA;EA1MZ;EA4MY;IACE,wBAAA;IACA,eAAA;EA1Md;EA6MY;IACE,2BAAA;EA3Md;AACF;;AAsNA;EACE,cAAA;EACA,6DAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;EACA,0CAAA;AAnNF;AAqNE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,6DAAA;EACA,eAAA;EACA,gCAAA;AAnNJ;AAqNI;EACE,6DAAA;AAnNN;AAsNI;EACE,SAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;AApNN;AAsNM;EACE,cAAA;EACA,eAAA;AApNR;AAwNI;EACE,oCAAA;EACA,YAAA;EACA,0CAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;AAtNN;AAwNM;EACE,oCAAA;AAtNR;AA2NE;EACE,aAAA;EACA,iBAAA;AAzNJ;AA2NI;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gCAAA;EACA,mBAAA;AAzNN;AA6NI;EACE,mBAAA;AA3NN;AA6NM;EACE,aAAA;EACA,2DAAA;EACA,SAAA;EACA,gBAAA;AA3NR;AA6NQ;EACE,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,yBAAA;EACA,yBAAA;AA3NV;AA6NU;EACE,qBAAA;EACA,mBAAA;AA3NZ;AA8NU;EACE,qBAAA;EACA,mBAAA;AA5NZ;AA+NU;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,qBAAA;AA7NZ;AAgOU;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,cAAA;AA9NZ;AAgOY;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AA9Nd;AAiOY;EACE,cAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;AA/Nd;AAkOY;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AAhOd;AAoOU;EACE,qBAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AAlOZ;AAoOY;EACE,mBAAA;EACA,cAAA;AAlOd;AAqOY;EACE,mBAAA;EACA,cAAA;AAnOd;AA2OI;EACE,mBAAA;AAzON;AA2OM;EACE,aAAA;EACA,4DAAA;EACA,SAAA;EACA,gBAAA;AAzOR;AA2OQ;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;AAzOV;AA2OU;EACE,mBAAA;EACA,qBAAA;AAzOZ;AA4OU;EACE,mBAAA;EACA,qBAAA;AA1OZ;AA6OU;EACE,0BAAA;EACA,wCAAA;AA3OZ;AA8OU;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,SAAA;AA5OZ;AA+OU;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AA7OZ;AA+OY;EACE,cAAA;EACA,eAAA;AA7Od;AA+Oc;EACE,cAAA;EACA,iBAAA;AA7OhB;AAiPY;EACE,cAAA;EACA,eAAA;AA/Od;AAiPc;EACE,cAAA;AA/OhB;AAmPY;EACE,cAAA;EACA,eAAA;EACA,aAAA;AAjPd;AAqPU;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;AAnPZ;AAqPY;EACE,mBAAA;EACA,YAAA;AAnPd;AAsPY;EACE,mBAAA;EACA,YAAA;AApPd;AA6PM;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;AA3PR;AA6PQ;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,QAAA;AA3PV;AA8PY;EACE,cAAA;EACA,gBAAA;AA5Pd;AAgQU;EACE,eAAA;EACA,cAAA;EACA,gBAAA;AA9PZ;AAiQU;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AA/PZ;AAmQQ;EACE,eAAA;EACA,cAAA;EACA,iBAAA;AAjQV;AAqQM;EACE,kBAAA;EACA,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AAnQR;AAqQQ;EACE,mBAAA;EACA,cAAA;EACA,yBAAA;AAnQV;AAsQQ;EACE,mBAAA;EACA,cAAA;EACA,yBAAA;AApQV;;AA4QA;EACE;IACE,cAAA;EAzQF;EA4QI;IACE,eAAA;EA1QN;EA6QI;IACE,eAAA;IACA,iBAAA;EA3QN;EA+QE;IACE,aAAA;EA7QJ;EA+QI;IACE,eAAA;EA7QN;EAgRI;IACE,0BAAA;IACA,SAAA;EA9QN;EAiRI;IACE,0BAAA;EA/QN;EAkRI;IACE,sBAAA;IACA,SAAA;EAhRN;EAkRM;IACE,wBAAA;EAhRR;AACF","sourcesContent":[".plan-selection-modal-overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background-color: rgba(195, 191, 191, 0.721);\r\n  backdrop-filter: blur(4px);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 10000;\r\n  padding: 20px;\r\n\r\n  .plan-selection-modal {\r\n    background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);\r\n    border-radius: 16px;\r\n    box-shadow: 0 25px 50px rgba(0, 0, 0, 0.3);\r\n    max-width: 900px;\r\n    width: 100%;\r\n    max-height: 90vh;\r\n    overflow-y: auto;\r\n    animation: modalSlideIn 0.3s ease-out;\r\n    border: 1px solid #e2e8f0;\r\n\r\n    @keyframes modalSlideIn {\r\n      from {\r\n        opacity: 0;\r\n        transform: translateY(-20px) scale(0.95);\r\n      }\r\n      to {\r\n        opacity: 1;\r\n        transform: translateY(0) scale(1);\r\n      }\r\n    }\r\n\r\n    .modal-header {\r\n      padding: 16px 24px;\r\n      display: flex;\r\n      justify-content: flex-end;\r\n      border-bottom: 1px solid #e2e8f0;\r\n\r\n      .close-button {\r\n        background: transparent;\r\n        border: none;\r\n        font-size: 24px;\r\n        color: #4a5568;\r\n        cursor: pointer;\r\n        transition: color 0.3s ease;\r\n        padding: 0;\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: center;\r\n\r\n        &:hover:not(:disabled) {\r\n          color: #2d3748;\r\n        }\r\n\r\n        &:disabled {\r\n          color: #cbd5e0;\r\n          cursor: not-allowed;\r\n          opacity: 0.5;\r\n        }\r\n      }\r\n    }\r\n\r\n    .loading-container {\r\n      padding: 60px 32px;\r\n      text-align: center;\r\n      color: #4a5568;\r\n      font-size: 16px;\r\n    }\r\n\r\n    .company-info {\r\n      padding: 24px 32px;\r\n      text-align: center;\r\n      border-bottom: 1px solid #e2e8f0;\r\n      background: #f8fafc;\r\n\r\n      h2 {\r\n        margin: 0 0 12px;\r\n        font-size: 26px;\r\n        font-weight: 700;\r\n        color: #1a202c;\r\n      }\r\n\r\n      .contact-info {\r\n        margin-bottom: 8px;\r\n        font-size: 14px;\r\n        color: #4a5568;\r\n\r\n        span {\r\n          margin: 0 4px;\r\n        }\r\n      }\r\n\r\n      .current-plan {\r\n        font-size: 14px;\r\n        color: #4a5568;\r\n\r\n        strong {\r\n          color: var(--primary-color);\r\n          font-weight: 600;\r\n        }\r\n      }\r\n    }\r\n\r\n    .plan-content {\r\n      padding: 32px;\r\n\r\n      .section-title {\r\n        margin: 0 0 20px;\r\n        font-size: 18px;\r\n        font-weight: 600;\r\n        color: #2d3748;\r\n      }\r\n\r\n      .plans-grid {\r\n        display: grid;\r\n        grid-template-columns: repeat(4, 1fr);\r\n        gap: 20px;\r\n        margin-bottom: 32px;\r\n\r\n        .plan-card {\r\n          position: relative;\r\n          background: white;\r\n          border: 2px solid #e2e8f0;\r\n          border-radius: 12px;\r\n          padding: 24px 20px;\r\n          text-align: center;\r\n          cursor: pointer;\r\n          transition: all 0.3s ease;\r\n\r\n          &:hover {\r\n            border-color: #cbd5e0;\r\n            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\r\n            transform: translateY(-2px);\r\n          }\r\n\r\n          &.selected {\r\n            border-color: var(--primary-color);\r\n            background: linear-gradient(135deg, rgba(102, 126, 234, 0.05) 0%, rgba(118, 75, 162, 0.05) 100%);\r\n            box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);\r\n          }\r\n\r\n          &.blurred {\r\n            opacity: 0.5;\r\n            filter: grayscale(40%);\r\n            \r\n            &:hover {\r\n              transform: translateY(-2px);\r\n              box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\r\n              border-color: #cbd5e0;\r\n            }\r\n          }\r\n\r\n          &.disabled {\r\n            opacity: 0.4;\r\n            cursor: not-allowed;\r\n            pointer-events: none;\r\n            background: #f7fafc;\r\n            border-color: #e2e8f0;\r\n            \r\n            &:hover {\r\n              transform: none;\r\n              box-shadow: none;\r\n              border-color: #e2e8f0;\r\n            }\r\n            \r\n            h4, .price {\r\n              color: #a0aec0;\r\n            }\r\n          }\r\n\r\n         &.highlighted {\r\n            box-shadow: 0 4px 15px rgba(102, 126, 234, 0.25);\r\n            transform: scale(1.02);\r\n            \r\n            &::before {\r\n              content: '';\r\n              position: absolute;\r\n              top: 0;\r\n              left: 0;\r\n              right: 0;\r\n              bottom: 0;\r\n              background: linear-gradient(135deg, rgba(102, 126, 234, 0.04) 0%, rgba(118, 75, 162, 0.04) 100%);\r\n              pointer-events: none;\r\n              border-radius: inherit;\r\n              z-index: 0;\r\n            }\r\n            \r\n            &:hover {\r\n              transform: scale(1.03);\r\n              box-shadow: 0 6px 20px rgba(102, 126, 234, 0.3);\r\n            }\r\n          }\r\n\r\n          .checkmark {\r\n            position: absolute;\r\n            top: 12px;\r\n            right: 12px;\r\n            color: var(--primary-color);\r\n            font-size: 24px;\r\n            z-index: 2;\r\n          }\r\n\r\n          .upgrade-badge {\r\n            position: absolute;\r\n            top: -12px;\r\n            right: -12px;\r\n            background: linear-gradient(135deg, var(--primary-color) 0%, #5a4ba0 100%);\r\n            color: white;\r\n            padding: 4px 10px;\r\n            border-radius: 12px;\r\n            font-size: 10px;\r\n            font-weight: 600;\r\n            z-index: 2;\r\n            box-shadow: 0 2px 8px rgba(102, 126, 234, 0.4);\r\n            letter-spacing: 0.3px;\r\n            text-transform: uppercase;\r\n          }\r\n\r\n          .current-plan-badge {\r\n            position: absolute;\r\n            top: -12px;\r\n            right: -12px;\r\n            background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);\r\n            color: white;\r\n            padding: 4px 10px;\r\n            border-radius: 12px;\r\n            font-size: 10px;\r\n            font-weight: 600;\r\n            z-index: 2;\r\n            box-shadow: 0 2px 8px rgba(245, 158, 11, 0.4);\r\n            letter-spacing: 0.3px;\r\n            text-transform: uppercase;\r\n          }\r\n\r\n          h4 {\r\n            margin: 0 0 12px;\r\n            font-size: 20px;\r\n            font-weight: 600;\r\n            color: #2d3748;\r\n            position: relative;\r\n            z-index: 1;\r\n          }\r\n\r\n          .price {\r\n            margin: 0;\r\n            font-size: 18px;\r\n            font-weight: 700;\r\n            color: var(--primary-color);\r\n            position: relative;\r\n            z-index: 1;\r\n          }\r\n\r\n          .price-container {\r\n            position: relative;\r\n            z-index: 1;\r\n\r\n            .base-price {\r\n              margin: 0 0 6px;\r\n              font-size: 17px;\r\n              font-weight: 600;\r\n              color: #2d3748;\r\n            }\r\n\r\n            .gst-info {\r\n              margin: 0 0 6px;\r\n              font-size: 13px;\r\n              font-weight: 500;\r\n              color: #718096;\r\n            }\r\n\r\n            .total-price {\r\n              margin: 0;\r\n              font-size: 18px;\r\n              font-weight: 700;\r\n              color: var(--primary-color);\r\n              padding-top: 6px;\r\n              border-top: 1px solid #e2e8f0;\r\n            }\r\n\r\n            &.enterprise-modern {\r\n      .enterprise-main {\r\n        font-size: 20px;\r\n        font-weight: 700;\r\n        color: #2d3748;\r\n        margin: 0 0 10px;\r\n      }\r\n\r\n      .enterprise-benefits {\r\n        font-size: 13px;\r\n        color: #718096;\r\n        line-height: 1.5;\r\n        margin: 0 0 12px;\r\n      }\r\n\r\n      .contact-badge {\r\n        display: inline-block;\r\n        background: linear-gradient(135deg, var(--primary-color) 0%, #5a4ba0 100%);\r\n        color: white;\r\n        padding: 6px 16px;\r\n        border-radius: 20px;\r\n        font-size: 12px;\r\n        font-weight: 600;\r\n        margin-top: 8px;\r\n      }\r\n    }\r\n\r\n    &.enterprise-premium {\r\n      .enterprise-badge {\r\n        display: inline-block;\r\n        background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);\r\n        color: white;\r\n        padding: 4px 12px;\r\n        border-radius: 12px;\r\n        font-size: 11px;\r\n        font-weight: 600;\r\n        margin-bottom: 10px;\r\n        letter-spacing: 0.5px;\r\n      }\r\n\r\n      .enterprise-tagline {\r\n        font-size: 18px;\r\n        font-weight: 700;\r\n        color: #2d3748;\r\n        margin: 0 0 12px;\r\n      }\r\n\r\n      .enterprise-features-hint {\r\n        font-size: 12px;\r\n        color: #4a5568;\r\n        line-height: 1.8;\r\n        text-align: left;\r\n        margin: 0;\r\n      }\r\n    }\r\n\r\n    &.enterprise-value {\r\n      .enterprise-label {\r\n        font-size: 16px;\r\n        font-weight: 600;\r\n        color: #2d3748;\r\n        margin: 0 0 10px;\r\n      }\r\n\r\n      .value-props {\r\n        font-size: 12px;\r\n        color: #4a5568;\r\n        line-height: 1.8;\r\n        text-align: left;\r\n        margin: 0 0 10px;\r\n      }\r\n\r\n      .pricing-note {\r\n        font-size: 13px;\r\n        font-weight: 600;\r\n        color: var(--primary-color);\r\n        margin: 0;\r\n      }\r\n    }\r\n\r\n    &.enterprise-minimal {\r\n      .enterprise-heading {\r\n        font-size: 20px;\r\n        font-weight: 700;\r\n        color: #2d3748;\r\n        margin: 0 0 12px;\r\n      }\r\n\r\n      .divider-line {\r\n        width: 60%;\r\n        height: 2px;\r\n        background: linear-gradient(90deg, transparent, var(--primary-color), transparent);\r\n        margin: 0 auto 12px;\r\n      }\r\n\r\n      .enterprise-subtext {\r\n        font-size: 13px;\r\n        color: #718096;\r\n        margin: 0 0 10px;\r\n        line-height: 1.5;\r\n      }\r\n\r\n      .action-text {\r\n        font-size: 14px;\r\n        font-weight: 600;\r\n        color: var(--primary-color);\r\n        margin: 0;\r\n      }\r\n    }\r\n\r\n    // Add custom-pricing class for simple implementation\r\n    .custom-pricing {\r\n      font-size: 20px;\r\n      font-weight: 700;\r\n      color: #2d3748;\r\n      margin: 0 0 8px;\r\n    }\r\n\r\n    .enterprise-description,\r\n    .enterprise-note {\r\n      font-size: 13px;\r\n      color: #718096;\r\n      line-height: 1.5;\r\n      margin: 0;\r\n    }\r\n          }\r\n        }\r\n      }\r\n\r\n      .billing-period-section {\r\n        margin-bottom: 24px;\r\n\r\n        label {\r\n          display: block;\r\n          margin-bottom: 8px;\r\n          font-size: 16px;\r\n          font-weight: 600;\r\n          color: #2d3748;\r\n        }\r\n\r\n        select {\r\n          width: 100%;\r\n          padding: 12px 16px;\r\n          font-size: 15px;\r\n          border: 2px solid #e2e8f0;\r\n          border-radius: 8px;\r\n          background: white;\r\n          color: #2d3748;\r\n          cursor: pointer;\r\n          transition: border-color 0.3s ease;\r\n\r\n          &:focus {\r\n            outline: none;\r\n            border-color: var(--primary-color);\r\n          }\r\n\r\n          &:hover {\r\n            border-color: #cbd5e0;\r\n          }\r\n        }\r\n      }\r\n\r\n      .terms-section {\r\n        margin-bottom: 24px;\r\n\r\n        .checkbox-label {\r\n          display: flex;\r\n          align-items: center;\r\n          gap: 10px;\r\n          cursor: pointer;\r\n\r\n          input[type=\"checkbox\"] {\r\n            width: 18px;\r\n            height: 18px;\r\n            cursor: pointer;\r\n          }\r\n\r\n          span {\r\n            font-size: 14px;\r\n            color: #4a5568;\r\n\r\n            .terms-link {\r\n              color: var(--primary-color);\r\n              text-decoration: none;\r\n              font-weight: 600;\r\n\r\n              &:hover {\r\n                text-decoration: underline;\r\n              }\r\n            }\r\n          }\r\n        }\r\n      }\r\n\r\n      .payment-status-message {\r\n        margin: 20px 0;\r\n        padding: 16px 20px;\r\n        border-radius: 10px;\r\n        display: flex;\r\n        align-items: center;\r\n        gap: 12px;\r\n        animation: slideDown 0.3s ease-out;\r\n\r\n        @keyframes slideDown {\r\n          from {\r\n            opacity: 0;\r\n            transform: translateY(-10px);\r\n          }\r\n          to {\r\n            opacity: 1;\r\n            transform: translateY(0);\r\n          }\r\n        }\r\n\r\n        .status-icon {\r\n          flex-shrink: 0;\r\n        }\r\n\r\n        p {\r\n          margin: 0;\r\n          font-size: 15px;\r\n          font-weight: 600;\r\n          line-height: 1.5;\r\n        }\r\n\r\n        &.success {\r\n          background: linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%);\r\n          border: 2px solid #6ee7b7;\r\n          color: #065f46;\r\n\r\n          .status-icon {\r\n            color: #059669;\r\n          }\r\n        }\r\n\r\n        &.error {\r\n          background: linear-gradient(135deg, #fee2e2 0%, #fecaca 100%);\r\n          border: 2px solid #fca5a5;\r\n          color: #991b1b;\r\n\r\n          .status-icon {\r\n            color: #dc2626;\r\n          }\r\n        }\r\n\r\n        &.processing {\r\n          background: linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%);\r\n          border: 2px solid #93c5fd;\r\n          color: #1e40af;\r\n\r\n          .status-icon {\r\n            color: #3b82f6;\r\n          }\r\n        }\r\n      }\r\n\r\n      .modal-footer {\r\n        text-align: center;\r\n        padding-top: 24px;\r\n        border-top: 1px solid #e2e8f0;\r\n\r\n        .payment-button {\r\n          background: var(--primary-color);\r\n          color: white;\r\n          border: none;\r\n          border-radius: 10px;\r\n          padding: 14px 40px;\r\n          font-size: 16px;\r\n          font-weight: 600;\r\n          cursor: pointer;\r\n          transition: all 0.3s ease;\r\n          width: 100%;\r\n          max-width: 300px;\r\n\r\n          &:hover:not(:disabled) {\r\n            box-shadow: 0 8px 25px rgba(102, 126, 234, 0.6);\r\n            transform: translateY(-2px);\r\n          }\r\n\r\n          &:active:not(:disabled) {\r\n            transform: translateY(0);\r\n          }\r\n\r\n          &:disabled {\r\n            background: #cbd5e0;\r\n            cursor: not-allowed;\r\n            opacity: 0.6;\r\n          }\r\n        }\r\n\r\n        .go-back {\r\n          margin: 16px 0 0;\r\n          font-size: 14px;\r\n          color: #4a5568;\r\n\r\n          .back-link {\r\n            background: none;\r\n            border: none;\r\n            color: var(--primary-color);\r\n            font-weight: 600;\r\n            cursor: pointer;\r\n            text-decoration: none;\r\n            padding: 0;\r\n            font-size: 14px;\r\n\r\n            &:hover:not(:disabled) {\r\n              text-decoration: underline;\r\n            }\r\n\r\n            &:disabled {\r\n              color: #cbd5e0;\r\n              cursor: not-allowed;\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n\r\n    // New styles for premium contact form\r\n    .premium-contact-form-container {\r\n      padding: 32px;\r\n      animation: fadeIn 0.3s ease-out;\r\n\r\n      @keyframes fadeIn {\r\n        from {\r\n          opacity: 0;\r\n        }\r\n        to {\r\n          opacity: 1;\r\n        }\r\n      }\r\n\r\n      .form-header {\r\n        text-align: center;\r\n        margin-bottom: 32px;\r\n\r\n        h3 {\r\n          font-size: 24px;\r\n          font-weight: 700;\r\n          color: #1a202c;\r\n          margin: 0 0 12px;\r\n        }\r\n\r\n        p {\r\n          font-size: 15px;\r\n          color: #4a5568;\r\n          line-height: 1.6;\r\n          max-width: 600px;\r\n          margin: 0 auto;\r\n        }\r\n      }\r\n\r\n      .form-notification {\r\n        margin-bottom: 24px;\r\n        padding: 14px 18px;\r\n        border-radius: 10px;\r\n        display: flex;\r\n        align-items: center;\r\n        gap: 12px;\r\n        animation: slideDown 0.3s ease-out;\r\n\r\n        @keyframes slideDown {\r\n          from {\r\n            opacity: 0;\r\n            transform: translateY(-10px);\r\n          }\r\n          to {\r\n            opacity: 1;\r\n            transform: translateY(0);\r\n          }\r\n        }\r\n\r\n        .notification-icon {\r\n          flex-shrink: 0;\r\n        }\r\n\r\n        p {\r\n          margin: 0;\r\n          font-size: 14px;\r\n          font-weight: 600;\r\n          line-height: 1.5;\r\n        }\r\n\r\n        &.success {\r\n          background: linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%);\r\n          border: 2px solid #6ee7b7;\r\n          color: #065f46;\r\n\r\n          .notification-icon {\r\n            color: #059669;\r\n          }\r\n        }\r\n\r\n        &.error {\r\n          background: linear-gradient(135deg, #fee2e2 0%, #fecaca 100%);\r\n          border: 2px solid #fca5a5;\r\n          color: #991b1b;\r\n\r\n          .notification-icon {\r\n            color: #dc2626;\r\n          }\r\n        }\r\n\r\n        &.warning {\r\n          background: linear-gradient(135deg, #fef3c7 0%, #fde68a 100%);\r\n          border: 2px solid #fcd34d;\r\n          color: #92400e;\r\n\r\n          .notification-icon {\r\n            color: #d97706;\r\n          }\r\n        }\r\n      }\r\n\r\n      .contact-form {\r\n        .form-row {\r\n          display: grid;\r\n          grid-template-columns: 1fr 1fr;\r\n          gap: 16px;\r\n          margin-bottom: 16px;\r\n        }\r\n\r\n        .form-group {\r\n          margin-bottom: 16px;\r\n\r\n          input,\r\n          textarea {\r\n            width: 100%;\r\n            padding: 12px 16px;\r\n            font-size: 15px;\r\n            border: 2px solid #e2e8f0;\r\n            border-radius: 8px;\r\n            background: white;\r\n            color: #2d3748;\r\n            transition: border-color 0.3s ease;\r\n            font-family: inherit;\r\n\r\n            &:focus {\r\n              outline: none;\r\n              border-color: var(--primary-color);\r\n            }\r\n\r\n            &:hover:not(:disabled) {\r\n              border-color: #cbd5e0;\r\n            }\r\n\r\n            &:disabled {\r\n              background: #f7fafc;\r\n              cursor: not-allowed;\r\n              opacity: 0.6;\r\n            }\r\n\r\n            &::placeholder {\r\n              color: #a0aec0;\r\n            }\r\n          }\r\n\r\n          textarea {\r\n            resize: vertical;\r\n            min-height: 120px;\r\n          }\r\n        }\r\n\r\n        .form-actions {\r\n          margin-top: 24px;\r\n          text-align: center;\r\n\r\n          .submit-button {\r\n            background: var(--primary-color);\r\n            color: white;\r\n            border: none;\r\n            border-radius: 10px;\r\n            padding: 14px 40px;\r\n            font-size: 16px;\r\n            font-weight: 600;\r\n            cursor: pointer;\r\n            transition: all 0.3s ease;\r\n            width: 100%;\r\n            max-width: 300px;\r\n\r\n            &:hover:not(:disabled) {\r\n              box-shadow: 0 8px 25px rgba(102, 126, 234, 0.6);\r\n              transform: translateY(-2px);\r\n            }\r\n\r\n            &:active:not(:disabled) {\r\n              transform: translateY(0);\r\n            }\r\n\r\n            &:disabled {\r\n              background: #cbd5e0;\r\n              cursor: not-allowed;\r\n              opacity: 0.6;\r\n            }\r\n          }\r\n\r\n          .go-back {\r\n            margin: 16px 0 0;\r\n            font-size: 14px;\r\n            color: #4a5568;\r\n\r\n            .back-link {\r\n              background: none;\r\n              border: none;\r\n              color: var(--primary-color);\r\n              font-weight: 600;\r\n              cursor: pointer;\r\n              text-decoration: none;\r\n              padding: 0;\r\n              font-size: 14px;\r\n\r\n              &:hover:not(:disabled) {\r\n                text-decoration: underline;\r\n              }\r\n\r\n              &:disabled {\r\n                color: #cbd5e0;\r\n                cursor: not-allowed;\r\n              }\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  // Mobile responsiveness\r\n  @media (max-width: 768px) {\r\n    padding: 16px;\r\n\r\n    .plan-selection-modal {\r\n      .company-info {\r\n        padding: 20px 24px;\r\n\r\n        h2 {\r\n          font-size: 22px;\r\n        }\r\n\r\n        .contact-info,\r\n        .current-plan {\r\n          font-size: 13px;\r\n        }\r\n      }\r\n\r\n      .plan-content {\r\n        padding: 24px;\r\n\r\n        .plans-grid {\r\n          grid-template-columns: 1fr;\r\n          gap: 16px;\r\n\r\n          .plan-card {\r\n            &.highlighted {\r\n              transform: scale(1.01);\r\n              \r\n              &:hover {\r\n                transform: scale(1.02);\r\n              }\r\n            }\r\n          }\r\n        }\r\n\r\n        .modal-footer {\r\n          .payment-button {\r\n            max-width: 100%;\r\n          }\r\n        }\r\n      }\r\n\r\n      .premium-contact-form-container {\r\n        padding: 24px;\r\n\r\n        .contact-form {\r\n          .form-row {\r\n            grid-template-columns: 1fr;\r\n          }\r\n\r\n          .form-actions {\r\n            .submit-button {\r\n              max-width: 100%;\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  @media (max-width: 480px) {\r\n    padding: 0;\r\n\r\n    .plan-selection-modal {\r\n      margin: 0;\r\n      border-radius: 0;\r\n      height: 100vh;\r\n      max-height: 100vh;\r\n\r\n      .company-info {\r\n        h2 {\r\n          font-size: 20px;\r\n        }\r\n\r\n        .contact-info {\r\n          flex-direction: column;\r\n          \r\n          span {\r\n            display: block;\r\n            margin: 2px 0;\r\n          }\r\n        }\r\n      }\r\n\r\n      .plan-content {\r\n        .plans-grid {\r\n          .plan-card {\r\n            padding: 20px 16px;\r\n\r\n            &.highlighted {\r\n              transform: scale(1.01);\r\n            }\r\n\r\n            h4 {\r\n              font-size: 18px;\r\n            }\r\n\r\n            .price {\r\n              font-size: 16px;\r\n            }\r\n\r\n            .upgrade-badge {\r\n              top: -10px;\r\n              right: -10px;\r\n              padding: 4px 10px;\r\n              font-size: 9px;\r\n            }\r\n\r\n            .current-plan-badge {\r\n              top: -10px;\r\n              right: -10px;\r\n              padding: 4px 10px;\r\n              font-size: 9px;\r\n            }\r\n          }\r\n        }\r\n      }\r\n\r\n      .premium-contact-form-container {\r\n        padding: 20px;\r\n\r\n        .form-header {\r\n          h3 {\r\n            font-size: 20px;\r\n          }\r\n\r\n          p {\r\n            font-size: 14px;\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n  .comparison-modal-overlay {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    background: rgba(0, 0, 0, 0.75);\r\n    backdrop-filter: blur(6px);\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    z-index: 10001;\r\n    padding: 20px;\r\n    animation: fadeIn 0.3s ease-out;\r\n\r\n    @keyframes fadeIn {\r\n      from { opacity: 0; }\r\n      to { opacity: 1; }\r\n    }\r\n\r\n    .comparison-modal {\r\n      background: white;\r\n      border-radius: 16px;\r\n      max-width: 1000px;\r\n      width: 100%;\r\n      max-height: 90vh;\r\n      overflow-y: auto;\r\n      box-shadow: 0 25px 50px rgba(0, 0, 0, 0.5);\r\n      animation: slideUp 0.3s ease-out;\r\n\r\n      @keyframes slideUp {\r\n        from {\r\n          opacity: 0;\r\n          transform: translateY(30px);\r\n        }\r\n        to {\r\n          opacity: 1;\r\n          transform: translateY(0);\r\n        }\r\n      }\r\n\r\n      .comparison-header {\r\n        padding: 24px 32px;\r\n        border-bottom: 2px solid #e2e8f0;\r\n        text-align: center;\r\n        background: linear-gradient(135deg, #f8fafc 0%, #ffffff 100%);\r\n\r\n        h3 {\r\n          margin: 0 0 8px;\r\n          font-size: 26px;\r\n          font-weight: 700;\r\n          color: #1a202c;\r\n        }\r\n\r\n        p {\r\n          margin: 0;\r\n          font-size: 15px;\r\n          color: #718096;\r\n        }\r\n      }\r\n\r\n      .comparison-content {\r\n        padding: 32px;\r\n\r\n        .comparison-grid {\r\n          display: grid;\r\n          grid-template-columns: 1fr auto 1fr;\r\n          gap: 24px;\r\n          align-items: start;\r\n\r\n          .plan-column {\r\n            background: #f8fafc;\r\n            border-radius: 12px;\r\n            overflow: hidden;\r\n            border: 2px solid #e2e8f0;\r\n\r\n            &.current {\r\n              .column-header {\r\n                background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%);\r\n              }\r\n            }\r\n\r\n            &.new {\r\n              border-color: var(--primary-color);\r\n              box-shadow: 0 4px 20px rgba(102, 126, 234, 0.2);\r\n\r\n              .column-header {\r\n                background: linear-gradient(135deg, var(--primary-color) 0%, #5a4ba0 100%);\r\n                color: white;\r\n                position: relative;\r\n\r\n                .upgrade-badge {\r\n                  position: absolute;\r\n                  top: 12px;\r\n                  right: 12px;\r\n                  background: rgba(255, 255, 255, 0.25);\r\n                  padding: 4px 12px;\r\n                  border-radius: 12px;\r\n                  font-size: 11px;\r\n                  font-weight: 600;\r\n                  text-transform: uppercase;\r\n                  letter-spacing: 0.5px;\r\n                }\r\n\r\n                .plan-price {\r\n                  color: rgba(255, 255, 255, 0.95);\r\n                }\r\n              }\r\n            }\r\n\r\n            .column-header {\r\n              padding: 20px;\r\n              text-align: center;\r\n\r\n              h4 {\r\n                margin: 0 0 8px;\r\n                font-size: 14px;\r\n                font-weight: 600;\r\n                text-transform: uppercase;\r\n                letter-spacing: 1px;\r\n                opacity: 0.8;\r\n              }\r\n\r\n              .plan-name {\r\n                margin: 0 0 8px;\r\n                font-size: 22px;\r\n                font-weight: 700;\r\n              }\r\n\r\n              .plan-price {\r\n                margin: 0;\r\n                font-size: 18px;\r\n                font-weight: 600;\r\n                color: #4a5568;\r\n              }\r\n            }\r\n\r\n            .column-body {\r\n              padding: 20px;\r\n              background: white;\r\n\r\n              .limits-section {\r\n                margin-bottom: 20px;\r\n                padding-bottom: 20px;\r\n                border-bottom: 1px solid #e2e8f0;\r\n\r\n                .limit-item {\r\n                  display: flex;\r\n                  justify-content: space-between;\r\n                  align-items: center;\r\n                  padding: 10px 0;\r\n                  font-size: 14px;\r\n\r\n                  .limit-label {\r\n                    color: #4a5568;\r\n                    font-weight: 500;\r\n                  }\r\n\r\n                  .limit-value {\r\n                    color: #1a202c;\r\n                    font-weight: 700;\r\n                    font-size: 16px;\r\n                    display: flex;\r\n                    align-items: center;\r\n                    gap: 8px;\r\n\r\n                    &.improved {\r\n                      color: var(--primary-color);\r\n                    }\r\n\r\n                    .increase {\r\n                      font-size: 12px;\r\n                      color: #10b981;\r\n                      background: #d1fae5;\r\n                      padding: 2px 8px;\r\n                      border-radius: 8px;\r\n                      font-weight: 600;\r\n                    }\r\n                  }\r\n                }\r\n              }\r\n\r\n              .features-section {\r\n                h5 {\r\n                  margin: 0 0 12px;\r\n                  font-size: 13px;\r\n                  font-weight: 600;\r\n                  text-transform: uppercase;\r\n                  color: #718096;\r\n                  letter-spacing: 0.5px;\r\n                }\r\n\r\n                .feature-item {\r\n                  display: flex;\r\n                  align-items: center;\r\n                  gap: 10px;\r\n                  padding: 8px 0;\r\n                  font-size: 14px;\r\n                  transition: all 0.2s ease;\r\n\r\n                  &.new-feature {\r\n                    background: linear-gradient(90deg, rgba(16, 185, 129, 0.1) 0%, transparent 100%);\r\n                    padding-left: 10px;\r\n                    margin-left: -10px;\r\n                    border-radius: 6px;\r\n\r\n                    .new-badge {\r\n                      margin-left: auto;\r\n                      background: #10b981;\r\n                      color: white;\r\n                      font-size: 10px;\r\n                      padding: 2px 8px;\r\n                      border-radius: 8px;\r\n                      font-weight: 600;\r\n                    }\r\n                  }\r\n\r\n                  .feature-icon {\r\n                    width: 20px;\r\n                    font-weight: 700;\r\n                    font-size: 16px;\r\n                  }\r\n\r\n                  .feature-label {\r\n                    color: #2d3748;\r\n                  }\r\n\r\n                  &.feature-enabled {\r\n                    .feature-icon {\r\n                      color: #10b981;\r\n                    }\r\n                  }\r\n\r\n                  &.feature-disabled {\r\n                    opacity: 0.4;\r\n\r\n                    .feature-icon {\r\n                      color: #cbd5e0;\r\n                    }\r\n                  }\r\n                }\r\n              }\r\n            }\r\n          }\r\n\r\n          .arrow-column {\r\n            display: flex;\r\n            flex-direction: column;\r\n            align-items: center;\r\n            justify-content: center;\r\n            gap: 8px;\r\n            padding-top: 100px;\r\n\r\n            .upgrade-arrow {\r\n              font-size: 40px;\r\n              color: var(--primary-color);\r\n              font-weight: 700;\r\n              animation: pulse 2s ease-in-out infinite;\r\n            }\r\n\r\n            .upgrade-text {\r\n              font-size: 11px;\r\n              font-weight: 700;\r\n              color: var(--primary-color);\r\n              letter-spacing: 1px;\r\n              writing-mode: vertical-rl;\r\n              text-orientation: mixed;\r\n            }\r\n\r\n            @keyframes pulse {\r\n              0%, 100% { opacity: 1; transform: translateX(0); }\r\n              50% { opacity: 0.7; transform: translateX(5px); }\r\n            }\r\n          }\r\n        }\r\n      }\r\n\r\n      .comparison-footer {\r\n        padding: 20px 32px;\r\n        border-top: 2px solid #e2e8f0;\r\n        display: flex;\r\n        justify-content: center;\r\n        gap: 16px;\r\n        background: #f8fafc;\r\n\r\n        button {\r\n          padding: 12px 32px;\r\n          border-radius: 10px;\r\n          font-size: 15px;\r\n          font-weight: 600;\r\n          cursor: pointer;\r\n          transition: all 0.3s ease;\r\n          border: none;\r\n\r\n          &.cancel-button {\r\n            background: white;\r\n            color: #4a5568;\r\n            border: 2px solid #e2e8f0;\r\n\r\n            &:hover {\r\n              background: #f7fafc;\r\n              border-color: #cbd5e0;\r\n            }\r\n          }\r\n\r\n          &.confirm-button {\r\n            background: var(--primary-color);\r\n            color: white;\r\n\r\n            &:hover {\r\n              box-shadow: 0 8px 25px rgba(102, 126, 234, 0.6);\r\n              transform: translateY(-2px);\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n\r\n    // Mobile responsive\r\n    @media (max-width: 768px) {\r\n      .comparison-modal {\r\n        .comparison-content {\r\n          padding: 20px;\r\n\r\n          .comparison-grid {\r\n            grid-template-columns: 1fr;\r\n            gap: 16px;\r\n\r\n            .arrow-column {\r\n              padding-top: 0;\r\n\r\n              .upgrade-arrow {\r\n                transform: rotate(90deg);\r\n                font-size: 30px;\r\n              }\r\n\r\n              .upgrade-text {\r\n                writing-mode: horizontal-tb;\r\n              }\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n}\r\n\r\n// Plan Comparison Styles\r\n.plan-comparison-container {\r\n  margin: 24px 0;\r\n  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);\r\n  border-radius: 12px;\r\n  border: 2px solid #cbd5e0;\r\n  overflow: hidden;\r\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);\r\n\r\n  .comparison-header {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    padding: 16px 20px;\r\n    background: linear-gradient(135deg, #004A9A 0%, #0066cc 100%);\r\n    cursor: pointer;\r\n    transition: background 0.3s ease;\r\n\r\n    &:hover {\r\n      background: linear-gradient(135deg, #003a7a 0%, #0055aa 100%);\r\n    }\r\n\r\n    h4 {\r\n      margin: 0;\r\n      color: white;\r\n      font-size: 18px;\r\n      font-weight: 600;\r\n      display: flex;\r\n      align-items: center;\r\n      gap: 10px;\r\n\r\n      .compare-icon {\r\n        color: #4ade80;\r\n        font-size: 20px;\r\n      }\r\n    }\r\n\r\n    .toggle-btn {\r\n      background: rgba(255, 255, 255, 0.2);\r\n      color: white;\r\n      border: 1px solid rgba(255, 255, 255, 0.3);\r\n      padding: 6px 14px;\r\n      border-radius: 6px;\r\n      cursor: pointer;\r\n      font-size: 13px;\r\n      font-weight: 500;\r\n      transition: all 0.3s ease;\r\n\r\n      &:hover {\r\n        background: rgba(255, 255, 255, 0.3);\r\n      }\r\n    }\r\n  }\r\n\r\n  .comparison-content {\r\n    padding: 20px;\r\n    background: white;\r\n\r\n    h5 {\r\n      margin: 0 0 14px 0;\r\n      font-size: 16px;\r\n      font-weight: 600;\r\n      color: #1a202c;\r\n      border-bottom: 2px solid #e2e8f0;\r\n      padding-bottom: 8px;\r\n    }\r\n\r\n    // Limits Section\r\n    .limits-section {\r\n      margin-bottom: 24px;\r\n\r\n      .limits-grid {\r\n        display: grid;\r\n        grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\r\n        gap: 16px;\r\n        margin-top: 12px;\r\n\r\n        .limit-item {\r\n          background: #f8fafc;\r\n          border-radius: 10px;\r\n          padding: 16px;\r\n          border: 2px solid #e2e8f0;\r\n          transition: all 0.3s ease;\r\n\r\n          &.upgrade {\r\n            border-color: #4ade80;\r\n            background: #f0fdf4;\r\n          }\r\n\r\n          &.downgrade {\r\n            border-color: #fbbf24;\r\n            background: #fffbeb;\r\n          }\r\n\r\n          .limit-label {\r\n            font-size: 13px;\r\n            color: #64748b;\r\n            font-weight: 500;\r\n            margin-bottom: 8px;\r\n            text-transform: uppercase;\r\n            letter-spacing: 0.5px;\r\n          }\r\n\r\n          .limit-comparison {\r\n            display: flex;\r\n            align-items: center;\r\n            justify-content: center;\r\n            gap: 12px;\r\n            margin: 12px 0;\r\n\r\n            .current-value {\r\n              font-size: 24px;\r\n              font-weight: 700;\r\n              color: #64748b;\r\n            }\r\n\r\n            .arrow {\r\n              color: #004A9A;\r\n              font-size: 18px;\r\n              display: flex;\r\n              align-items: center;\r\n            }\r\n\r\n            .new-value {\r\n              font-size: 24px;\r\n              font-weight: 700;\r\n              color: #004A9A;\r\n            }\r\n          }\r\n\r\n          .change-badge {\r\n            display: inline-block;\r\n            padding: 4px 12px;\r\n            border-radius: 20px;\r\n            font-size: 12px;\r\n            font-weight: 600;\r\n            text-align: center;\r\n\r\n            &.positive {\r\n              background: #d1fae5;\r\n              color: #065f46;\r\n            }\r\n\r\n            &.negative {\r\n              background: #fee2e2;\r\n              color: #991b1b;\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n\r\n    // Features Section\r\n    .features-section {\r\n      margin-bottom: 24px;\r\n\r\n      .features-grid {\r\n        display: grid;\r\n        grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\r\n        gap: 12px;\r\n        margin-top: 12px;\r\n\r\n        .feature-item {\r\n          display: flex;\r\n          align-items: center;\r\n          justify-content: space-between;\r\n          padding: 12px 16px;\r\n          background: #f8fafc;\r\n          border-radius: 8px;\r\n          border: 1px solid #e2e8f0;\r\n          transition: all 0.3s ease;\r\n          position: relative;\r\n\r\n          &.added {\r\n            background: #f0fdf4;\r\n            border-color: #4ade80;\r\n          }\r\n\r\n          &.removed {\r\n            background: #fef2f2;\r\n            border-color: #f87171;\r\n          }\r\n\r\n          &:hover {\r\n            transform: translateX(4px);\r\n            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\r\n          }\r\n\r\n          .feature-label {\r\n            font-size: 14px;\r\n            color: #1a202c;\r\n            font-weight: 500;\r\n            flex: 1;\r\n          }\r\n\r\n          .feature-status {\r\n            display: flex;\r\n            align-items: center;\r\n            gap: 8px;\r\n\r\n            .has-feature {\r\n              color: #10b981;\r\n              font-size: 16px;\r\n\r\n              &.new {\r\n                color: #004A9A;\r\n                font-weight: bold;\r\n              }\r\n            }\r\n\r\n            .no-feature {\r\n              color: #ef4444;\r\n              font-size: 16px;\r\n\r\n              &.new {\r\n                color: #dc2626;\r\n              }\r\n            }\r\n\r\n            .arrow {\r\n              color: #64748b;\r\n              font-size: 14px;\r\n              margin: 0 4px;\r\n            }\r\n          }\r\n\r\n          .feature-badge {\r\n            position: absolute;\r\n            top: -6px;\r\n            right: 8px;\r\n            padding: 2px 8px;\r\n            border-radius: 12px;\r\n            font-size: 10px;\r\n            font-weight: 600;\r\n            text-transform: uppercase;\r\n            letter-spacing: 0.5px;\r\n\r\n            &.added {\r\n              background: #10b981;\r\n              color: white;\r\n            }\r\n\r\n            &.removed {\r\n              background: #ef4444;\r\n              color: white;\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n\r\n    // Price Section\r\n    .price-section {\r\n      .price-comparison {\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: center;\r\n        gap: 20px;\r\n        margin: 16px 0;\r\n        padding: 16px;\r\n        background: #f8fafc;\r\n        border-radius: 10px;\r\n\r\n        .price-item {\r\n          display: flex;\r\n          flex-direction: column;\r\n          align-items: center;\r\n          gap: 6px;\r\n\r\n          &.new {\r\n            .value {\r\n              color: #004A9A;\r\n              font-weight: 700;\r\n            }\r\n          }\r\n\r\n          .label {\r\n            font-size: 13px;\r\n            color: #64748b;\r\n            font-weight: 500;\r\n          }\r\n\r\n          .value {\r\n            font-size: 22px;\r\n            font-weight: 600;\r\n            color: #1a202c;\r\n          }\r\n        }\r\n\r\n        .price-arrow {\r\n          font-size: 24px;\r\n          color: #004A9A;\r\n          font-weight: bold;\r\n        }\r\n      }\r\n\r\n      .price-difference {\r\n        text-align: center;\r\n        padding: 12px;\r\n        border-radius: 8px;\r\n        font-size: 15px;\r\n        font-weight: 600;\r\n        margin-top: 12px;\r\n\r\n        &.increase {\r\n          background: #fef3c7;\r\n          color: #92400e;\r\n          border: 1px solid #fbbf24;\r\n        }\r\n\r\n        &.decrease {\r\n          background: #d1fae5;\r\n          color: #065f46;\r\n          border: 1px solid #34d399;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n// Responsive styles for plan comparison\r\n@media (max-width: 768px) {\r\n  .plan-comparison-container {\r\n    margin: 16px 0;\r\n\r\n    .comparison-header {\r\n      h4 {\r\n        font-size: 15px;\r\n      }\r\n\r\n      .toggle-btn {\r\n        font-size: 11px;\r\n        padding: 4px 10px;\r\n      }\r\n    }\r\n\r\n    .comparison-content {\r\n      padding: 16px;\r\n\r\n      h5 {\r\n        font-size: 14px;\r\n      }\r\n\r\n      .limits-section .limits-grid {\r\n        grid-template-columns: 1fr;\r\n        gap: 12px;\r\n      }\r\n\r\n      .features-section .features-grid {\r\n        grid-template-columns: 1fr;\r\n      }\r\n\r\n      .price-section .price-comparison {\r\n        flex-direction: column;\r\n        gap: 12px;\r\n\r\n        .price-arrow {\r\n          transform: rotate(90deg);\r\n        }\r\n      }\r\n    }\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
